/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+db1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Hl1t","wrapper":"wrapper__1GvZd","section":"section__-WZEH","sliceWrap":"sliceWrap__1k-t_","slice":"slice__24mKQ","key":"key__jD7VM","keyInner":"keyInner__1zU5a","text":"text__ChQj9","textDescriptionInner":"textDescriptionInner__QHGRR","textInner":"textInner__30-7y","hidden":"hidden__3DfOZ"};

/***/ }),

/***/ "03Lb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textBG":"textBG__W6DVa","textBGYellow":"textBGYellow__ggSDg","textBGGreen":"textBGGreen__3C6iA","textBGBlue":"textBGBlue__JD8_u","textBGTransparent":"textBGTransparent__3y49L","emoji":"emoji__kNqaE"};

/***/ }),

/***/ "2O4m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "3rrf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__13sXc","chartWrapper":"chartWrapper__2Ji89","dataPoint":"dataPoint__U3xv1","sideRight":"sideRight__1-vz_","flipper":"flipper__3buwo","circleWrap":"circleWrap__2uPyZ","circle":"circle__30z2o","circleInner":"circleInner__3md1R","percentage":"percentage__-JcBj","percentageText":"percentageText__2OTDh","fact":"fact__1KSxS","spaced":"spaced__3vyvZ","hidden":"hidden__2lsKX"};

/***/ }),

/***/ "4ueM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2-7c6","chartWrapper":"chartWrapper__RClLw","responsive":"responsive__Frya5","circleWrap":"circleWrap__1HYud","circle":"circle__1kUN5","fact":"fact__2S744","factBelow":"factBelow__1UQWh","hidden":"hidden__dNI70"};

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "6JeW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__3ETcO","copy":"copy__1S_Aq","sideRight":"sideRight__3G5eH"};

/***/ }),

/***/ "6ROg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"compare":"compare__geYJe","compareFact":"compareFact__1ws1E","compareFactEven":"compareFactEven__2QJ-0","smallAtMobile":"smallAtMobile__2wSa-"};

/***/ }),

/***/ "82uG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__2XmJq","standfirst":"standfirst__1N0uk","magnetic":"magnetic__3BBYz","magnetCenter":"magnetCenter__27CVO","onRight":"onRight__2RCJW","section1":"section1__rDAb7","section2":"section2__29Dir","section3":"section3__29eb1","section4":"section4__VUpMp","section5":"section5__1TfZO"};

/***/ }),

/***/ "8C0a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__DiIfB","snug":"snug__1EkJD"};

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "A8Bg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__XwqXj","logo":"logo__2wWKE","links":"links__z5fNV","shareLink":"shareLink__1qm6Q"};

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "DmCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}



/***/ }),

/***/ "Et4k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("eW0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_consolidated_events__ = __webpack_require__("DmCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants.above;
  }

  return constants.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

// React.PureComponent was added in React 15.3.0
var BaseClass = typeof __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].PureComponent !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].PureComponent : __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].Component;

// Calls a function when you scroll to the element.

var Waypoint = function (_BaseClass) {
  _inherits(Waypoint, _BaseClass);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly and to avoid layout thrashing, we want to delay the
        // initial execution until the next tick.
        this.cancelOnNextTick = onNextTick(function () {
          _this2.cancelOnNextTick = null;

          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (false) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var _this3 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved, so we need to recompute its position on the
        // page. This happens via handleScroll in a way that forces layout to be
        // computed.
        //
        // We want this to be deferred to avoid forcing layout during render, which
        // causes layout thrashing. And, if we already have this work enqueued, we
        // can just wait for that to happen instead of enqueueing again.
        if (this.cancelOnNextTick) {
          return;
        }

        this.cancelOnNextTick = onNextTick(function () {
          _this3.cancelOnNextTick = null;
          _this3._handleScroll(null);
        });
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelOnNextTick) {
          this.cancelOnNextTick();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;

        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (false) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (false) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var children = this.props.children;

        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children)) {
          var ref = function () {
            function ref(node) {
              _this4.refElement(node);
              if (children.ref) {
                children.ref(node);
              }
            }

            return ref;
          }();

          return __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].cloneElement(children, { ref: ref });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["a" /* default */].cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(BaseClass);

Waypoint.above = constants.above;
Waypoint.below = constants.below;
Waypoint.inside = constants.inside;
Waypoint.invisible = constants.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

/* harmony default export */ __webpack_exports__["a"] = (Waypoint);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "F+sh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"emoji":"emoji__1jVRZ"};

/***/ }),

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J/c/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"text":"text__1zVEw","center":"center__3xHGi","tight":"tight__2wRTV","flush":"flush__2svUH"};

/***/ }),

/***/ "JbTr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__2qGvt","line":"line__dCWmp"};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style_0 = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style_0);

// EXTERNAL MODULE: ./components/Header/style.css
var Header_style = __webpack_require__("A8Bg");
var Header_style_default = /*#__PURE__*/__webpack_require__.n(Header_style);

// EXTERNAL MODULE: ./components/Container/style.css
var Container_style = __webpack_require__("8C0a");
var Container_style_default = /*#__PURE__*/__webpack_require__.n(Container_style);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./components/Container/index.js




var Container_Container = function Container(_ref) {
	var _cn;

	var children = _ref.children,
	    snug = _ref.snug;
	return Object(preact_min["h"])(
		'div',
		{ className: classnames_default()(Container_style_default.a.root, (_cn = {}, _cn[Container_style_default.a.snug] = snug, _cn)) },
		children
	);
};

/* harmony default export */ var components_Container = (Container_Container);
// EXTERNAL MODULE: ./components/Logo/style.css
var Logo_style = __webpack_require__("h0Qy");
var Logo_style_default = /*#__PURE__*/__webpack_require__.n(Logo_style);

// CONCATENATED MODULE: ./components/Logo/index.js




var Logo__ref2 = Object(preact_min["h"])(
	'svg',
	{
		width: '120px',
		height: '56px',
		viewBox: '0 0 120 56',
		version: '1.1',
		xmlns: 'http://www.w3.org/2000/svg'
	},
	Object(preact_min["h"])(
		'title',
		null,
		'totaljobs'
	),
	Object(preact_min["h"])(
		'g',
		{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
		Object(preact_min["h"])(
			'g',
			null,
			Object(preact_min["h"])('path', {
				d: 'M93.3080402,45.6119598 C89.3163317,45.6119598 86.1829146,42.4963819 86.1829146,38.4290452 L86.1829146,26.9998995 L88.7442211,26.9998995 L88.7442211,32.859196 C89.9703518,31.8393467 91.5643216,31.2461307 93.3080402,31.2461307 C97.2997487,31.2461307 100.433166,34.3622111 100.433166,38.4290452 C100.433166,42.4963819 97.2997487,45.6119598 93.3080402,45.6119598 Z M88.7442211,38.4290452 C88.7442211,40.9933668 90.7741206,43.1303015 93.3080402,43.1303015 C95.8419598,43.1303015 97.8718593,40.9933668 97.8718593,38.4290452 C97.8718593,35.8923618 95.8419598,33.7277889 93.3080402,33.7277889 C90.7741206,33.7277889 88.7442211,35.8923618 88.7442211,38.4290452 Z M54.8758794,45.6119598 L52.3148241,45.6119598 L52.3148241,43.9988945 C51.0886935,45.0194975 49.5082915,45.6119598 47.7507538,45.6119598 C43.7590452,45.6119598 40.6256281,42.4963819 40.6256281,38.4290452 C40.6256281,34.3622111 43.7590452,31.2461307 47.7507538,31.2461307 C51.7424623,31.2461307 54.8758794,34.3622111 54.8758794,38.4290452 L54.8758794,45.6119598 Z M43.2005025,38.4290452 C43.2005025,40.9659799 45.230402,43.1303015 47.7643216,43.1303015 C50.2984925,43.1303015 52.328392,40.9659799 52.328392,38.4290452 C52.328392,35.8647236 50.2984925,33.7277889 47.7643216,33.7277889 C45.2168342,33.7277889 43.2005025,35.8647236 43.2005025,38.4290452 Z M105.269598,45.6119598 C107.748995,45.6119598 109.860804,43.7096985 109.860804,41.1453769 C109.860804,39.0084422 108.348492,38.0292965 106.781658,37.3127136 C105.215075,36.5953769 103.675628,36.0715075 103.675628,34.8860804 C103.675628,34.141608 104.356784,33.5624623 105.078894,33.5624623 C105.814573,33.5624623 106.468342,34.0863317 106.781658,34.748392 L108.86608,33.6177387 C108.157789,32.1426131 106.85,31.2599497 105.215075,31.2599497 C103.048995,31.2461307 101.277889,32.9833166 101.277889,35.1757789 C101.277889,37.0227638 102.367839,37.7672362 103.838945,38.5810553 L106.345729,39.9456281 C106.945226,40.3453769 107.28593,40.6901005 107.28593,41.4207538 C107.28593,42.5790452 106.345729,43.3235176 105.25603,43.3235176 C104.029899,43.3235176 103.375879,42.6064322 102.830905,41.5865829 L100.637437,42.5926131 C101.359548,44.4953769 103.334925,45.6119598 105.269598,45.6119598 Z M77.7907035,45.6119598 C73.798995,45.6119598 70.6655779,42.4963819 70.6655779,38.4290452 C70.6655779,34.3622111 73.798995,31.2461307 77.7907035,31.2461307 C81.7824121,31.2461307 84.9158291,34.3622111 84.9158291,38.4290452 C84.9158291,42.4963819 81.7824121,45.6119598 77.7907035,45.6119598 Z M73.2404523,38.4290452 C73.2404523,40.9659799 75.2567839,43.1303015 77.8045226,43.1303015 C80.3384422,43.1303015 82.3683417,40.9659799 82.3683417,38.4290452 C82.3683417,35.8647236 80.3520101,33.7277889 77.8045226,33.7277889 C75.2567839,33.7277889 73.2404523,35.8647236 73.2404523,38.4290452 Z M63.4723618,45.6119598 C68.4859296,45.6119598 69.2896985,41.4071859 69.2896985,37.2159799 L69.2896985,30.6946231 L66.6057789,30.6946231 L66.6057789,37.229799 L66.6057789,37.4639698 C66.6057789,39.6973869 66.5512563,43.0752764 63.581407,43.0752764 C62.818593,43.0752764 62.0419598,42.8132161 61.4424623,42.3446231 L60.0937186,44.6607035 C61.1562814,45.2948744 62.2190955,45.6119598 63.4723618,45.6119598 Z M38.1326633,45.6119598 L38.1326633,33.6865829 L40.639196,33.6865829 L40.639196,31.2599497 L38.1326633,31.2599497 L38.1326633,26.9998995 L35.5713568,26.9998995 L35.5713568,31.2599497 L34.1680905,31.2599497 L34.1680905,33.6865829 L35.5713568,33.6865829 L35.5713568,45.6119598 L38.1326633,45.6119598 Z M26.5253769,45.6119598 C22.5472362,45.6119598 19.4002513,42.4963819 19.4002513,38.4290452 C19.4002513,34.3622111 22.5336683,31.2461307 26.5253769,31.2461307 C30.5170854,31.2461307 33.6505025,34.3622111 33.6505025,38.4290452 C33.6505025,42.4963819 30.5170854,45.6119598 26.5253769,45.6119598 Z M21.9751256,38.4290452 C21.9751256,40.9659799 23.991206,43.1303015 26.5389447,43.1303015 C29.0728643,43.1303015 31.1027638,40.9659799 31.1027638,38.4290452 C31.1027638,35.8647236 29.0864322,33.7277889 26.5389447,33.7277889 C23.991206,33.7277889 21.9751256,35.8647236 21.9751256,38.4290452 Z M17.1251256,45.6119598 C12.1115578,45.6119598 11.3077889,41.4071859 11.3077889,37.2159799 L11.3077889,33.6865829 L10,33.6865829 L10,31.2599497 L11.3213568,31.2599497 L11.3213568,26.9998995 L14.0052764,26.9998995 L14.0052764,31.2599497 L16.4846734,31.2599497 L16.4846734,33.6865829 L13.9917085,33.6865829 L13.9917085,37.229799 L13.9917085,37.4777889 C13.9917085,39.7114573 14.0459799,43.0890955 17.0160804,43.0890955 C17.7788945,43.0890955 18.5555276,42.8270352 19.1550251,42.3584422 L20.4899497,44.6747739 C19.4409548,45.2948744 18.378392,45.6119598 17.1251256,45.6119598 Z M56.5379397,45.5981407 L59.0992462,45.5981407 L59.0992462,26.9998995 L56.5379397,26.9998995 L56.5379397,45.5981407 Z M66.6603015,29.6609548 L69.2896985,29.6609548 L69.2896985,27.0001508 L66.6603015,27.0001508 L66.6603015,29.6609548 Z',
				fill: '#66BD00'
			})
		)
	)
);

var Logo_Logo = function Logo(_ref) {
	var _cn;

	var trim = _ref.trim;
	return Object(preact_min["h"])(
		'a',
		{
			className: classnames_default()(Logo_style_default.a.logo, (_cn = {}, _cn[Logo_style_default.a.trim] = trim, _cn)),
			href: 'https://www.totaljobs.com/insidejob/',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		Logo__ref2
	);
};

/* harmony default export */ var components_Logo = (Logo_Logo);
// CONCATENATED MODULE: ./utils/objToHash.js
/* harmony default export */ var objToHash = (function (obj) {
	return Object.keys(obj).map(function (key) {
		return key + '=' + encodeURIComponent(obj[key]);
	}).join('&');
});
// CONCATENATED MODULE: ./components/Header/index.js






var Header__ref2 = Object(preact_min["h"])(components_Logo, null);

var Header_Header = function Header(_ref) {
	var tweetText = _ref.tweetText;

	var social = [{
		name: 'twitter',
		baseUrl: 'https://twitter.com/share',
		icon: 'M22.05 5.17a5.38 5.38 0 0 0 2.26-3 9.88 9.88 0 0 1-3.26 1.31 5 5 0 0 0-3.74-1.7 5.27 5.27 0 0 0-5.13 5.4 5.61 5.61 0 0 0 .13 1.24A14.33 14.33 0 0 1 1.74 2.77a5.67 5.67 0 0 0-.69 2.73A5.48 5.48 0 0 0 3.33 10 4.94 4.94 0 0 1 1 9.32v.07a5.34 5.34 0 0 0 4.12 5.3 4.64 4.64 0 0 1-1.35.19 5.15 5.15 0 0 1-1-.09 5.16 5.16 0 0 0 4.79 3.75 9.89 9.89 0 0 1-6.37 2.32A8.24 8.24 0 0 1 0 20.78a14 14 0 0 0 7.86 2.43c9.44 0 14.59-8.24 14.59-15.39v-.7A10.71 10.71 0 0 0 25 4.32a9.83 9.83 0 0 1-2.95.85z',
		params: {
			url: "https://total-jobs-covering.beyondwordsstudio.com",
			text: tweetText
		}
	}, {
		name: 'facebook',
		baseUrl: 'https://www.facebook.com/sharer/sharer.php',
		icon: 'M14.47 25h-5.3V12.5H6.52V8.19h2.65V5.6c0-3.51 1.5-5.6 5.75-5.6h3.53v4.31h-2.21c-1.65 0-1.76.6-1.76 1.72v2.16h4L18 12.5h-3.53V25z',
		params: {
			u: "https://total-jobs-covering.beyondwordsstudio.com"
		}
	}];

	return Object(preact_min["h"])(
		'div',
		{ className: Header_style_default.a.root },
		Object(preact_min["h"])(
			components_Container,
			{ snug: true },
			Object(preact_min["h"])(
				'div',
				{ className: Header_style_default.a.logo },
				Header__ref2
			),
			Object(preact_min["h"])(
				'div',
				{ className: Header_style_default.a.links },
				social.map(function (_ref3) {
					var name = _ref3.name,
					    baseUrl = _ref3.baseUrl,
					    params = _ref3.params,
					    icon = _ref3.icon;
					return Object(preact_min["h"])(
						'a',
						{
							className: Header_style_default.a.shareLink,
							href: baseUrl + '?' + objToHash(params),
							target: '_blank',
							rel: 'noopener noreferrer'
						},
						Object(preact_min["h"])(
							'svg',
							{
								width: 16,
								height: 16,
								viewBox: '0 0 25 25',
								fill: 'currentColor'
							},
							Object(preact_min["h"])(
								'title',
								null,
								'Share on ',
								name
							),
							Object(preact_min["h"])('path', { d: icon })
						)
					);
				})
			)
		)
	);
};

/* harmony default export */ var components_Header = (Header_Header);
// EXTERNAL MODULE: ./components/Intro/style.css
var Intro_style = __webpack_require__("l8Hw");
var Intro_style_default = /*#__PURE__*/__webpack_require__.n(Intro_style);

// EXTERNAL MODULE: ./components/SectionTitle/style.css
var SectionTitle_style = __webpack_require__("vstC");
var SectionTitle_style_default = /*#__PURE__*/__webpack_require__.n(SectionTitle_style);

// CONCATENATED MODULE: ./components/SectionTitle/index.js



var SectionTitle_SectionTitle = function SectionTitle(_ref) {
	var title = _ref.title;
	return Object(preact_min["h"])(
		'div',
		{ className: SectionTitle_style_default.a.sectionTitleWrapper },
		Object(preact_min["h"])(
			'h2',
			{ className: SectionTitle_style_default.a.title },
			title
		)
	);
};

/* harmony default export */ var components_SectionTitle = (SectionTitle_SectionTitle);
// EXTERNAL MODULE: ./components/TextWithBackground/style.css
var TextWithBackground_style = __webpack_require__("03Lb");
var TextWithBackground_style_default = /*#__PURE__*/__webpack_require__.n(TextWithBackground_style);

// EXTERNAL MODULE: ../node_modules/string-replace-to-array/string-replace-to-array.js
var string_replace_to_array = __webpack_require__("WL61");
var string_replace_to_array_default = /*#__PURE__*/__webpack_require__.n(string_replace_to_array);

// EXTERNAL MODULE: ../node_modules/emoji-regex/index.js
var emoji_regex = __webpack_require__("nzRV");
var emoji_regex_default = /*#__PURE__*/__webpack_require__.n(emoji_regex);

// EXTERNAL MODULE: ./components/Emoji/style.css
var Emoji_style = __webpack_require__("F+sh");
var Emoji_style_default = /*#__PURE__*/__webpack_require__.n(Emoji_style);

// CONCATENATED MODULE: ./components/Emoji/index.js

// import ifEmoji from 'if-emoji';


var Emoji_Emoji = function Emoji(_ref) {
  var children = _ref.children;
  return Object(preact_min["h"])(
    'span',
    { className: Emoji_style_default.a.emoji },
    children
  );
};

/* harmony default export */ var components_Emoji = (Emoji_Emoji);
// CONCATENATED MODULE: ./components/TextWithBackground/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var TextWithBackground_TextWithBackground = function TextWithBackground(_ref) {
	var _cn;

	var _ref$tag = _ref.tag,
	    Tag = _ref$tag === undefined ? 'span' : _ref$tag,
	    children = _ref.children,
	    bg = _ref.bg,
	    className = _ref.className,
	    color = _ref.color,
	    _ref$highlight = _ref.highlight,
	    highlight = _ref$highlight === undefined ? [] : _ref$highlight,
	    _ref$highlightColors = _ref.highlightColors,
	    highlightColors = _ref$highlightColors === undefined ? ['yellow'] : _ref$highlightColors,
	    _ref$link = _ref.link,
	    link = _ref$link === undefined ? 'people change their personality at work' : _ref$link,
	    _ref$url = _ref.url,
	    url = _ref$url === undefined ? 'https://www.totaljobs.com/insidejob/bringing-your-true-self-to-work/' : _ref$url,
	    _ref$link2 = _ref.link2,
	    link2 = _ref$link2 === undefined ? 'you’re twice as likely' : _ref$link2,
	    _ref$url2 = _ref.url2,
	    url2 = _ref$url2 === undefined ? 'https://www.totaljobs.com/insidejob/lgbtq-people-continue-to-feel-displaced-in-the-workplace/' : _ref$url2,
	    rest = _objectWithoutProperties(_ref, ['tag', 'children', 'bg', 'className', 'color', 'highlight', 'highlightColors', 'link', 'url', 'link2', 'url2']);

	var match = -1;
	var strings = highlight.length ? string_replace_to_array_default()(children[0], new RegExp(highlight.join('|'), 'g'), function (foundString, offset, test, blah) {
		match = match + 1;
		return Object(preact_min["h"])(
			TextWithBackground,
			{ bg: highlightColors[match] },
			foundString
		);
	}) : [children[0]];

	var wrappedEmoji = string_replace_to_array_default()(strings, emoji_regex_default()(), function (string) {
		return Object(preact_min["h"])(
			components_Emoji,
			null,
			string
		);
	});

	var wrappedLink = string_replace_to_array_default()(wrappedEmoji, new RegExp(link, 'g'), function (string) {
		return Object(preact_min["h"])(
			'a',
			{ href: url, target: '_blank', rel: 'noopener noreferrer' },
			string
		);
	});

	wrappedLink = string_replace_to_array_default()(wrappedLink, new RegExp(link2, 'g'), function (string) {
		return Object(preact_min["h"])(
			'a',
			{ href: url2, target: '_blank', rel: 'noopener noreferrer' },
			string
		);
	});

	var isStandardColor = ['white', 'blue', 'green', 'yellow', 'transparent'].includes(bg);

	var style = isStandardColor ? null : {
		boxShadow: '0.2rem 0.2rem 0 ' + bg + ', -0.2rem -0.2rem 0 ' + bg + ',\n\t\t\t\t\t0.2rem -0.2rem 0 ' + bg + ', -0.2rem 0.2rem 0 ' + bg,
		backgroundColor: '' + bg
	};

	return Object(preact_min["h"])(
		Tag,
		_extends({
			className: classnames_default()(TextWithBackground_style_default.a.textBG, (_cn = {}, _cn[className] = className, _cn[TextWithBackground_style_default.a.textBGTransparent] = bg === 'transparent', _cn[TextWithBackground_style_default.a.textBGBlue] = bg === 'blue', _cn[TextWithBackground_style_default.a.textBGGreen] = bg === 'green', _cn[TextWithBackground_style_default.a.textBGYellow] = bg === 'yellow', _cn))
		}, rest),
		Object(preact_min["h"])(
			'span',
			{ style: style },
			wrappedLink
		)
	);
};

/* harmony default export */ var components_TextWithBackground = (TextWithBackground_TextWithBackground);
// EXTERNAL MODULE: ./components/Magnetic/style.css
var Magnetic_style = __webpack_require__("JbTr");
var Magnetic_style_default = /*#__PURE__*/__webpack_require__.n(Magnetic_style);

// CONCATENATED MODULE: ./components/Magnetic/index.js
var Magnetic__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function calcAngleDegrees(x, y) {
	return Math.atan2(y, x) * 180 / Math.PI;
}

var Magnetic_Magnetic = function (_Component) {
	_inherits(Magnetic, _Component);

	Magnetic.prototype.getLines = function getLines() {
		var _props = this.props,
		    _props$rows = _props.rows,
		    rows = _props$rows === undefined ? 5 : _props$rows,
		    _props$columns = _props.columns,
		    columns = _props$columns === undefined ? 24 : _props$columns,
		    _props$x = _props.x,
		    x = _props$x === undefined ? 50 : _props$x,
		    _props$y = _props.y,
		    y = _props$y === undefined ? 50 : _props$y,
		    _props$width = _props.width,
		    width = _props$width === undefined ? 100 : _props$width,
		    _props$height = _props.height,
		    height = _props$height === undefined ? 100 : _props$height,
		    _props$leftColor = _props.leftColor,
		    leftColor = _props$leftColor === undefined ? 'red' : _props$leftColor,
		    _props$rightColor = _props.rightColor,
		    rightColor = _props$rightColor === undefined ? 'blue' : _props$rightColor;


		var perRow = 100 / rows;
		var perCol = 100 / columns;

		var percentagePosition = {
			x: x / width * 100,
			y: y / height * 100
		};

		return Array.from(Array(rows * columns)).map(function (_, i) {
			var id = i;
			var col = Math.floor(i / rows);
			var row = i % rows;
			var x = col * perCol;
			var y = row * perRow;

			var rotation = calcAngleDegrees(x + perCol / 2 - percentagePosition.x, y + perRow / 2 - percentagePosition.y);

			var halfCol = columns / 2;
			var halfRow = rows / 2;

			return {
				id: id,
				x: x,
				y: y,
				col: col,
				row: row,
				opacity: 0.75 - Math.abs(row - halfRow) / halfRow + (0.75 - Math.abs(col - halfCol) / halfCol),
				rotation: rotation,
				color: x / perCol >= columns / 2 ? rightColor : leftColor
			};
		});
	};

	Magnetic.prototype.updateLines = function updateLines() {
		var _props2 = this.props,
		    _props2$rows = _props2.rows,
		    rows = _props2$rows === undefined ? 5 : _props2$rows,
		    _props2$columns = _props2.columns,
		    columns = _props2$columns === undefined ? 25 : _props2$columns,
		    _props2$x = _props2.x,
		    x = _props2$x === undefined ? 50 : _props2$x,
		    _props2$y = _props2.y,
		    y = _props2$y === undefined ? 50 : _props2$y,
		    _props2$width = _props2.width,
		    width = _props2$width === undefined ? 100 : _props2$width,
		    _props2$height = _props2.height,
		    height = _props2$height === undefined ? 100 : _props2$height;


		var perRow = 100 / rows;
		var perCol = 100 / columns;

		var percentagePosition = {
			x: x / width * 100,
			y: y / height * 100
		};

		return this.state.lines.map(function (line, i) {
			var x = line.col * perCol;
			var y = line.row * perRow;

			return Magnetic__extends({}, line, {
				rotation: calcAngleDegrees(x + perCol / 2 - percentagePosition.x, y + perRow / 2 - percentagePosition.y)
			});
		});
	};

	function Magnetic(props) {
		_classCallCheck(this, Magnetic);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.getLines = _this.getLines.bind(_this);
		_this.updateLines = _this.updateLines.bind(_this);

		_this.state = {
			lines: []
		};
		return _this;
	}

	Magnetic.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		window.addEventListener('load', function (event) {
			setTimeout(function () {
				_this2.setState({
					lines: _this2.getLines()
				});
			}, 100);
		});
	};

	Magnetic.prototype.render = function render() {
		if (!this.state.lines.length) {
			return Object(preact_min["h"])('div', { key: 'wrapper', className: Magnetic_style_default.a.wrap, style: { opacity: 0 } });
		}

		var _props3 = this.props,
		    _props3$rows = _props3.rows,
		    rows = _props3$rows === undefined ? 5 : _props3$rows,
		    _props3$columns = _props3.columns,
		    columns = _props3$columns === undefined ? 25 : _props3$columns;


		var perRow = 100 / rows;
		var perCol = 100 / columns;

		var lines = this.updateLines();

		return Object(preact_min["h"])(
			'div',
			{ key: 'wrapper', className: Magnetic_style_default.a.wrap },
			lines.map(function (_ref, i) {
				var x = _ref.x,
				    y = _ref.y,
				    rotation = _ref.rotation,
				    color = _ref.color,
				    opacity = _ref.opacity,
				    row = _ref.row;
				return Object(preact_min["h"])('div', {
					key: i,
					className: Magnetic_style_default.a.line,
					style: {
						top: y + '%',
						left: x + '%',
						width: perCol + '%',
						height: perRow + '%',
						transform: 'rotate(' + (rotation + 270) + 'deg)',
						opacity: opacity,
						color: color
					}
				});
			})
		);
	};

	return Magnetic;
}(preact_min["Component"]);

/* harmony default export */ var components_Magnetic = (Magnetic_Magnetic);
// CONCATENATED MODULE: ./components/MouseTracker/index.js
var MouseTracker__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function MouseTracker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MouseTracker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MouseTracker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MouseTracker_Mouse = function (_Component) {
	MouseTracker__inherits(Mouse, _Component);

	Mouse.prototype.getSizes = function getSizes(e) {
		var _e$target$getBounding = e.target.getBoundingClientRect(),
		    width = _e$target$getBounding.width,
		    height = _e$target$getBounding.height,
		    left = _e$target$getBounding.left,
		    top = _e$target$getBounding.top;

		this.setState({
			width: width,
			height: height,
			top: top,
			left: left
		});
	};

	Mouse.prototype.handleMouseMove = function handleMouseMove(e) {
		this.setState({
			x: e.clientX - this.state.left,
			y: e.clientY - this.state.top
		});
	};

	function Mouse(props) {
		MouseTracker__classCallCheck(this, Mouse);

		var _this = MouseTracker__possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.getSizes = _this.getSizes.bind(_this);
		_this.state = { x: 25, y: 25, height: 100, width: 100 };
		return _this;
	}

	Mouse.prototype.render = function render() {
		var _this2 = this;

		var className = this.props.className;


		return Object(preact_min["h"])(
			'div',
			{
				className: className,
				onMouseMove: this.handleMouseMove,
				onMouseEnter: this.getSizes,
				ref: function ref(elem) {
					return _this2.elem = elem;
				}
			},
			this.props.render(MouseTracker__extends({}, this.state))
		);
	};

	return Mouse;
}(preact_min["Component"]);

/* harmony default export */ var MouseTracker = (MouseTracker_Mouse);
// EXTERNAL MODULE: ./components/Chapter/style.css
var Chapter_style = __webpack_require__("82uG");
var Chapter_style_default = /*#__PURE__*/__webpack_require__.n(Chapter_style);

// CONCATENATED MODULE: ./components/Chapter/index.js
var Chapter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var colors = [{
	leftColor: '#9ce4c9',
	rightColor: '#fff'
}, {
	leftColor: '#fff',
	rightColor: '#cdf1e4'
}, {
	leftColor: '#fff',
	rightColor: '#b7e5de'
}, {
	leftColor: '#fff',
	rightColor: '#b9dce9'
}, {
	leftColor: '#fff',
	rightColor: '#9bbbf2'
}, {
	leftColor: '#9dbcf1',
	rightColor: '#fff'
}];

var Chapter_Chapter = function Chapter(_ref) {
	var _cn, _cn2;

	var children = _ref.children,
	    title = _ref.title,
	    standFirst = _ref.standFirst,
	    _ref$highlight = _ref.highlight,
	    highlight = _ref$highlight === undefined ? [] : _ref$highlight,
	    onRight = _ref.onRight,
	    _ref$section = _ref.section,
	    section = _ref$section === undefined ? 0 : _ref$section;
	return Object(preact_min["h"])(
		'div',
		{
			className: classnames_default()(Chapter_style_default.a.wrap, (_cn = {}, _cn[Chapter_style_default.a.onRight] = onRight, _cn[Chapter_style_default.a['section' + section]] = section, _cn))
		},
		Object(preact_min["h"])(
			components_Container,
			null,
			section !== 1 && section !== 5 && Object(preact_min["h"])(MouseTracker, {
				className: classnames_default()(Chapter_style_default.a.magnetic, (_cn2 = {}, _cn2[Chapter_style_default.a.magnetCenter] = section === 0, _cn2)),
				render: function render(mouse) {
					return Object(preact_min["h"])(components_Magnetic, Chapter__extends({}, mouse, {
						rows: section === 0 ? 15 : 7
					}, colors[section]));
				}
			}),
			title && Object(preact_min["h"])(components_SectionTitle, { title: title }),
			standFirst && Object(preact_min["h"])(
				components_TextWithBackground,
				{
					highlight: highlight,
					highlightColors: ['yellow'],
					tag: 'h3',
					className: Chapter_style_default.a.standfirst
				},
				standFirst
			),
			children
		)
	);
};

/* harmony default export */ var components_Chapter = (Chapter_Chapter);
// EXTERNAL MODULE: ./copy/intro.txt
var intro = __webpack_require__("RtUu");
var intro_default = /*#__PURE__*/__webpack_require__.n(intro);

// CONCATENATED MODULE: ./components/Intro/index.js






var Intro__ref = Object(preact_min["h"])(
	components_TextWithBackground,
	{ tag: 'p' },
	intro["sectionIntro"]
);

var Intro_Intro = function Intro() {
	return Object(preact_min["h"])(
		components_Chapter,
		{ onRight: true },
		Object(preact_min["h"])(
			'div',
			{ className: Intro_style_default.a.wrap },
			Object(preact_min["h"])('div', { className: Intro_style_default.a.beginArrow }),
			Object(preact_min["h"])(
				'h1',
				{ className: Intro_style_default.a.title },
				intro["title"]
			),
			Object(preact_min["h"])(
				components_TextWithBackground,
				{ className: Intro_style_default.a.standfirst, tag: 'p' },
				intro["standfirst"]
			),
			Object(preact_min["h"])(
				'div',
				{ className: Intro_style_default.a.descContainer },
				Object(preact_min["h"])(
					'p',
					{ className: Intro_style_default.a.descWrapper },
					Object(preact_min["h"])(
						'span',
						{ className: Intro_style_default.a.descName },
						intro["miniTitle"]
					),
					Object(preact_min["h"])(
						'span',
						{ className: Intro_style_default.a.descNoun },
						intro["miniDesc"]
					)
				),
				Intro__ref,
				Object(preact_min["h"])(
					'ul',
					{ className: Intro_style_default.a.descriptionCopyContainer },
					intro["sections"].map(function (_ref2) {
						var emoji = _ref2.emoji,
						    text = _ref2.text;
						return Object(preact_min["h"])(
							components_TextWithBackground,
							{
								'data-emoji': emoji,
								tag: 'li',
								className: Intro_style_default.a.descriptionCopy
							},
							text
						);
					})
				)
			),
			Object(preact_min["h"])('div', { className: Intro_style_default.a.beginArrow + ' ' + Intro_style_default.a.shortArrow }),
			Object(preact_min["h"])(
				'p',
				{ className: Intro_style_default.a.introFact },
				intro["fact"]
			),
			Object(preact_min["h"])('div', { className: Intro_style_default.a.endArrow })
		)
	);
};

/* harmony default export */ var components_Intro = (Intro_Intro);
// EXTERNAL MODULE: ./components/CircleGraph/style.css
var CircleGraph_style = __webpack_require__("Zr0Q");
var CircleGraph_style_default = /*#__PURE__*/__webpack_require__.n(CircleGraph_style);

// CONCATENATED MODULE: ./utils/calcAreaPercentage.js
/* harmony default export */ var calcAreaPercentage = (function (num, max) {
	return Math.sqrt(max * max * Math.PI * (num / max) / Math.PI) / max * 100;
});
// CONCATENATED MODULE: ./components/CircleGraph/index.js






var positionsTop = [true, false, false, true];
var positionsLeft = [false, true, false, true];

var CircleGraph_CircleGraph = function CircleGraph(_ref) {
	var _cn;

	var data = _ref.data,
	    inView = _ref.inView,
	    isAlternative = _ref.isAlternative;
	return Object(preact_min["h"])(
		'div',
		{
			className: classnames_default()(CircleGraph_style_default.a.vizContainer, (_cn = {}, _cn[CircleGraph_style_default.a.hidden] = !inView, _cn[CircleGraph_style_default.a.alternative] = isAlternative, _cn))
		},
		data.map(function (_ref2, i) {
			var _cn2;

			var percentage = _ref2.percentage,
			    fact = _ref2.fact;
			return Object(preact_min["h"])(
				'div',
				{
					className: classnames_default()(CircleGraph_style_default.a.fact, (_cn2 = {}, _cn2[CircleGraph_style_default.a.factTop] = positionsTop[i], _cn2[CircleGraph_style_default.a.factLeft] = isAlternative ? !positionsLeft[i] : positionsLeft[i], _cn2))
				},
				Object(preact_min["h"])(
					'div',
					{
						className: CircleGraph_style_default.a.responsive,
						style: {
							transitionDelay: 0.2 * i + 's'
						}
					},
					Object(preact_min["h"])(
						'div',
						{
							className: CircleGraph_style_default.a.bubbleWrap,
							style: {
								width: calcAreaPercentage(percentage, 65) + '%'
							}
						},
						Object(preact_min["h"])(
							'div',
							{ className: CircleGraph_style_default.a.bubble },
							Object(preact_min["h"])(
								'div',
								{ className: CircleGraph_style_default.a.bubbleText },
								percentage,
								'%'
							)
						)
					)
				),
				Object(preact_min["h"])(
					components_TextWithBackground,
					{
						bg: 'transparent',
						className: CircleGraph_style_default.a.label,
						style: {
							transitionDelay: 0.2 * i + 0.2 + 's'
						}
					},
					fact
				)
			);
		})
	);
};

/* harmony default export */ var components_CircleGraph = (CircleGraph_CircleGraph);
// EXTERNAL MODULE: ./components/ChartTitle/style.css
var ChartTitle_style = __webpack_require__("J/c/");
var ChartTitle_style_default = /*#__PURE__*/__webpack_require__.n(ChartTitle_style);

// CONCATENATED MODULE: ./components/ChartTitle/index.js
var ChartTitle__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ChartTitle__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var ChartTitle_ChartTitle = function ChartTitle(_ref) {
	var _cn;

	var _ref$tag = _ref.tag,
	    tag = _ref$tag === undefined ? 'h2' : _ref$tag,
	    children = _ref.children,
	    _ref$center = _ref.center,
	    center = _ref$center === undefined ? true : _ref$center,
	    tight = _ref.tight,
	    flush = _ref.flush,
	    rest = ChartTitle__objectWithoutProperties(_ref, ['tag', 'children', 'center', 'tight', 'flush']);

	return Object(preact_min["h"])(
		components_TextWithBackground,
		ChartTitle__extends({
			bg: 'white',
			className: classnames_default()(ChartTitle_style_default.a.text, (_cn = {}, _cn[ChartTitle_style_default.a.tight] = tight, _cn[ChartTitle_style_default.a.flush] = flush, _cn[ChartTitle_style_default.a.center] = center, _cn)),
			tag: tag
		}, rest),
		children
	);
};

/* harmony default export */ var components_ChartTitle = (ChartTitle_ChartTitle);
// EXTERNAL MODULE: ../node_modules/react-waypoint/es/index.js
var es = __webpack_require__("Et4k");

// CONCATENATED MODULE: ./components/InView/index.js


function InView__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InView__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function InView__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var InView_InView = function (_Component) {
	InView__inherits(InView, _Component);

	InView.prototype.setInView = function setInView() {
		this.setState({ inView: true });
	};

	InView.prototype.setOutOfView = function setOutOfView() {
		this.setState({ inView: false });
	};

	function InView(props) {
		InView__classCallCheck(this, InView);

		var _this = InView__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			inView: false
		};

		_this.setInView = _this.setInView.bind(_this);
		_this.setOutOfView = _this.setOutOfView.bind(_this);
		return _this;
	}

	InView.prototype.render = function render() {
		var render = this.props.render;
		var inView = this.state.inView;


		return Object(preact_min["h"])(
			'div',
			null,
			Object(preact_min["h"])(
				es["a" /* default */],
				{
					onEnter: this.setInView,
					topOffset: '0%',
					bottomOffset: '45%',
					onLeave: this.setOutOfView
				},
				Object(preact_min["h"])(
					'div',
					null,
					render(inView)
				)
			)
		);
	};

	return InView;
}(preact_min["Component"]);

/* harmony default export */ var components_InView = (InView_InView);
// CONCATENATED MODULE: ./components/IntroViz/index.js







var IntroViz__ref2 = Object(preact_min["h"])(
	'p',
	null,
	intro["respondents"]
);

var IntroViz_IntroViz = function IntroViz(_ref) {
	var copy = _ref.copy;
	return Object(preact_min["h"])(
		components_Chapter,
		{ section: 1 },
		intro["vizTitle"].map(function (t, i) {
			return Object(preact_min["h"])(
				components_ChartTitle,
				{ tag: 'p', tight: true },
				t.text
			);
		}),
		IntroViz__ref2,
		Object(preact_min["h"])(components_InView, { render: function render(inView) {
				return Object(preact_min["h"])(components_CircleGraph, { data: intro["viz"], inView: inView });
			} })
	);
};

/* harmony default export */ var components_IntroViz = (IntroViz_IntroViz);
// EXTERNAL MODULE: ./components/PhysicalChanges/style.css
var PhysicalChanges_style = __webpack_require__("WqJV");
var PhysicalChanges_style_default = /*#__PURE__*/__webpack_require__.n(PhysicalChanges_style);

// EXTERNAL MODULE: ./components/TextComparison/style.css
var TextComparison_style = __webpack_require__("6ROg");
var TextComparison_style_default = /*#__PURE__*/__webpack_require__.n(TextComparison_style);

// EXTERNAL MODULE: ./components/LineWrapper/style.css
var LineWrapper_style = __webpack_require__("Zu9o");
var LineWrapper_style_default = /*#__PURE__*/__webpack_require__.n(LineWrapper_style);

// CONCATENATED MODULE: ./components/LineWrapper/index.js




var LineWrapper_LineWrapper = function LineWrapper(_ref) {
	var _cn;

	var children = _ref.children,
	    isEnd = _ref.isEnd,
	    plain = _ref.plain,
	    tight = _ref.tight,
	    className = _ref.className,
	    snugPadding = _ref.snugPadding,
	    topTight = _ref.topTight,
	    trim = _ref.trim;
	return Object(preact_min["h"])(
		'div',
		{
			className: classnames_default()(LineWrapper_style_default.a.wrap, (_cn = {}, _cn[LineWrapper_style_default.a.isEnd] = isEnd, _cn[LineWrapper_style_default.a.plain] = plain, _cn[LineWrapper_style_default.a.tight] = tight, _cn[LineWrapper_style_default.a.trim] = trim, _cn[LineWrapper_style_default.a.topTight] = topTight, _cn[LineWrapper_style_default.a.snugPadding] = snugPadding, _cn[className] = className, _cn))
		},
		children
	);
};

/* harmony default export */ var components_LineWrapper = (LineWrapper_LineWrapper);
// CONCATENATED MODULE: ./components/TextComparison/index.js






var TextComparison_TextComparison = function TextComparison(_ref) {
	var _cn;

	var items = _ref.items,
	    _ref$smallAtMobile = _ref.smallAtMobile,
	    smallAtMobile = _ref$smallAtMobile === undefined ? true : _ref$smallAtMobile;
	return Object(preact_min["h"])(
		components_LineWrapper,
		{
			plain: true,
			tight: true,
			snugPadding: true,
			className: classnames_default()(TextComparison_style_default.a.compare, (_cn = {}, _cn[TextComparison_style_default.a.smallAtMobile] = smallAtMobile, _cn))
		},
		items.map(function (text, i) {
			var _cn2;

			return Object(preact_min["h"])(
				components_TextWithBackground,
				{
					bg: 'transparent',
					className: classnames_default()(TextComparison_style_default.a.compareFact, (_cn2 = {}, _cn2[TextComparison_style_default.a.compareFactEven] = !(i % 2), _cn2))
				},
				text
			);
		})
	);
};

/* harmony default export */ var components_TextComparison = (TextComparison_TextComparison);
// EXTERNAL MODULE: ./components/SliceChart/style.css
var SliceChart_style = __webpack_require__("3rrf");
var SliceChart_style_default = /*#__PURE__*/__webpack_require__.n(SliceChart_style);

// CONCATENATED MODULE: ./components/SliceChart/Circle.js



var Circle_Circle = function Circle(_ref) {
	var _ref$size = _ref.size,
	    size = _ref$size === undefined ? 100 : _ref$size,
	    totalSliceWidth = _ref.totalSliceWidth,
	    percentage = _ref.percentage,
	    fact = _ref.fact,
	    singleSliceWidth = _ref.singleSliceWidth,
	    color = _ref.color,
	    num = _ref.num,
	    percentageInline = _ref.percentageInline,
	    onRight = _ref.onRight;
	return Object(preact_min["h"])(
		'div',
		{
			className: SliceChart_style_default.a.dataPoint,
			style: {
				height: size + '%'
			}
		},
		Object(preact_min["h"])(
			'div',
			{ className: SliceChart_style_default.a.flipper },
			Object(preact_min["h"])(
				'div',
				{
					className: SliceChart_style_default.a.circleWrap,
					style: {
						transform: 'rotate(' + (totalSliceWidth - 90) + 'deg)'
					}
				},
				Object(preact_min["h"])(
					'div',
					{
						className: SliceChart_style_default.a.circle,
						style: {
							transform: 'translateZ(0)  rotate(' + (90 - totalSliceWidth) + 'deg)',
							width: size + '%'
						}
					},
					percentageInline && Object(preact_min["h"])(
						'div',
						{
							className: SliceChart_style_default.a.percentage,
							style: {
								transform: 'rotate(' + totalSliceWidth / 2 + 'deg) rotateY(-' + (onRight ? 180 : 0) + 'deg)'
							}
						},
						Object(preact_min["h"])(
							'span',
							{ className: SliceChart_style_default.a.percentageText },
							percentage,
							'%'
						)
					),
					Object(preact_min["h"])('div', {
						className: SliceChart_style_default.a.circleInner,
						style: {
							background: color,
							transform: 'rotate(' + singleSliceWidth * num + 'deg)'
						}
					})
				)
			)
		),
		fact && Object(preact_min["h"])(
			'div',
			{
				className: SliceChart_style_default.a.fact,
				style: {
					transitionDuration: 0.2 * num + 0.2 + 's'
				}
			},
			percentage,
			'% ',
			fact
		)
	);
};

/* harmony default export */ var SliceChart_Circle = (Circle_Circle);
// EXTERNAL MODULE: ./components/TextWrapper/style.css
var TextWrapper_style = __webpack_require__("6JeW");
var TextWrapper_style_default = /*#__PURE__*/__webpack_require__.n(TextWrapper_style);

// CONCATENATED MODULE: ./components/TextWrapper/index.js
var TextWrapper__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function TextWrapper__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var TextWrapper_TextWrapper = function TextWrapper(_ref) {
	var _cn;

	var onRight = _ref.onRight,
	    copy = _ref.copy,
	    children = _ref.children,
	    rest = TextWrapper__objectWithoutProperties(_ref, ['onRight', 'copy', 'children']);

	return Object(preact_min["h"])(
		components_LineWrapper,
		null,
		Object(preact_min["h"])(
			'div',
			{
				className: classnames_default()(TextWrapper_style_default.a.wrap, (_cn = {}, _cn[TextWrapper_style_default.a.sideRight] = onRight, _cn))
			},
			Object(preact_min["h"])(
				components_TextWithBackground,
				TextWrapper__extends({
					tag: 'p',
					bg: 'transparent'
				}, rest, {
					className: TextWrapper_style_default.a.copy
				}),
				copy
			),
			children
		)
	);
};

/* harmony default export */ var components_TextWrapper = (TextWrapper_TextWrapper);
// CONCATENATED MODULE: ./components/SliceChart/index.js
var SliceChart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var SliceChart_SliceChart = function SliceChart(_ref) {
	var _cn, _cn2;

	var data = _ref.data,
	    copy = _ref.copy,
	    _ref$max = _ref.max,
	    max = _ref$max === undefined ? 50 : _ref$max,
	    _ref$totalSliceWidth = _ref.totalSliceWidth,
	    totalSliceWidth = _ref$totalSliceWidth === undefined ? 60 : _ref$totalSliceWidth,
	    onRight = _ref.onRight,
	    inView = _ref.inView,
	    highlight = _ref.highlight,
	    highlightColors = _ref.highlightColors;

	var normalizedData = data.map(function (datum) {
		return SliceChart__extends({}, datum, {
			size: calcAreaPercentage(datum.percentage, max)
		});
	});

	var singleSliceWidth = totalSliceWidth / normalizedData.length;

	return Object(preact_min["h"])(
		components_TextWrapper,
		{
			copy: copy,
			onRight: !!onRight,
			highlight: highlight,
			highlightColors: highlightColors
		},
		Object(preact_min["h"])(
			'div',
			{
				className: classnames_default()((_cn = {}, _cn[SliceChart_style_default.a.spaced] = data.length > 2, _cn[SliceChart_style_default.a.sideRight] = onRight, _cn))
			},
			Object(preact_min["h"])(
				'div',
				{ className: SliceChart_style_default.a.container },
				Object(preact_min["h"])(
					'div',
					{ className: classnames_default()(SliceChart_style_default.a.chartWrapper, (_cn2 = {}, _cn2[SliceChart_style_default.a.hidden] = !inView, _cn2)) },
					Object(preact_min["h"])(SliceChart_Circle, {
						percentage: max,
						size: 100,
						totalSliceWidth: totalSliceWidth,
						singleSliceWidth: singleSliceWidth,
						percentageInline: true,
						onRight: onRight
					}),
					Object(preact_min["h"])(
						'div',
						null,
						normalizedData.map(function (circle, i) {
							return Object(preact_min["h"])(SliceChart_Circle, SliceChart__extends({}, circle, {
								onRight: onRight,
								num: i,
								totalSliceWidth: totalSliceWidth,
								singleSliceWidth: singleSliceWidth
							}));
						})
					)
				)
			)
		)
	);
};

/* harmony default export */ var components_SliceChart = (SliceChart_SliceChart);
// EXTERNAL MODULE: ./components/EmojiGraph/style.css
var EmojiGraph_style = __webpack_require__("yE6s");
var EmojiGraph_style_default = /*#__PURE__*/__webpack_require__.n(EmojiGraph_style);

// CONCATENATED MODULE: ./components/EmojiGraph/index.js





var EmojiGraph_EmojiGraph = function EmojiGraph(_ref) {
	var _cn;

	var data = _ref.data,
	    emoji = _ref.emoji,
	    isEnd = _ref.isEnd,
	    inView = _ref.inView;

	var emojiNumber = function emojiNumber(number) {
		var emojiDiv = [];

		for (var i = 0; i < number; i++) {
			emojiDiv.push(Object(preact_min["h"])(
				'div',
				{
					style: {
						transitionDelay: i * 0.025 + 's'
					},
					className: EmojiGraph_style_default.a.emoji
				},
				emoji
			));
		}

		return emojiDiv;
	};

	return Object(preact_min["h"])(
		components_LineWrapper,
		{ isEnd: isEnd, topTight: true },
		Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(EmojiGraph_style_default.a.container, (_cn = {}, _cn[EmojiGraph_style_default.a.hidden] = !inView, _cn)) },
			data.map(function (data, index) {
				return Object(preact_min["h"])(
					'div',
					{ className: EmojiGraph_style_default.a.emojiWrapper },
					emojiNumber(data.number)
				);
			})
		)
	);
};

/* harmony default export */ var components_EmojiGraph = (EmojiGraph_EmojiGraph);
// EXTERNAL MODULE: ./components/AreaComparison/style.css
var AreaComparison_style = __webpack_require__("cs8j");
var AreaComparison_style_default = /*#__PURE__*/__webpack_require__.n(AreaComparison_style);

// CONCATENATED MODULE: ./components/AreaComparison/index.js






var AreaComparison_AreaComparison = function AreaComparison(_ref) {
	var _cn;

	var data = _ref.data,
	    masterCircleSize = _ref.masterCircleSize,
	    masterCirclePercentage = _ref.masterCirclePercentage,
	    wrapperClass = _ref.wrapperClass,
	    numberClass = _ref.numberClass,
	    inView = _ref.inView,
	    isEnd = _ref.isEnd,
	    color = _ref.color,
	    topTight = _ref.topTight;
	return Object(preact_min["h"])(
		components_LineWrapper,
		{ isEnd: isEnd, topTight: topTight },
		Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(AreaComparison_style_default.a.wrapper, (_cn = {}, _cn[AreaComparison_style_default.a.hidden] = !inView, _cn)) },
			Object(preact_min["h"])(
				'div',
				{ className: AreaComparison_style_default.a.vizContainer },
				data.map(function (_ref2, i) {
					var _cn2;

					var percentage = _ref2.percentage,
					    fact = _ref2.fact;
					return Object(preact_min["h"])(
						'div',
						{
							className: classnames_default()(AreaComparison_style_default.a.circleWrapper, (_cn2 = {}, _cn2[AreaComparison_style_default.a.whiteBlue] = color === 'whiteBlue', _cn2[AreaComparison_style_default.a.blueWhite] = color === 'blueWhite', _cn2))
						},
						Object(preact_min["h"])('div', {
							className: AreaComparison_style_default.a.circle,
							style: {
								width: calcAreaPercentage(percentage, masterCirclePercentage) * 2 + '%',
								height: calcAreaPercentage(percentage, masterCirclePercentage) + '%',
								transitionDelay: 0.1 * i + 0.2 + 's'
							}
						}),
						Object(preact_min["h"])(
							'p',
							{
								className: AreaComparison_style_default.a.vizParagraph,
								style: {
									transitionDelay: 0.1 * i + 0.4 + 's'
								}
							},
							Object(preact_min["h"])(
								'span',
								null,
								percentage,
								'%'
							),
							' ',
							fact
						)
					);
				})
			)
		)
	);
};

/* harmony default export */ var components_AreaComparison = (AreaComparison_AreaComparison);
// EXTERNAL MODULE: ./components/RadialChart/style.css
var RadialChart_style = __webpack_require__("+db1");
var RadialChart_style_default = /*#__PURE__*/__webpack_require__.n(RadialChart_style);

// CONCATENATED MODULE: ./components/RadialChart/index.js






var getFill = function getFill(fill, secondHalfFill, oddFill, i, j, max) {
	if (secondHalfFill && i >= max / 2) {
		return secondHalfFill;
	}

	if (oddFill && j % 2) {
		return oddFill;
	}

	return fill;
};

var RadialChart_RadialChart = function RadialChart(_ref) {
	var _cn;

	var _ref$data = _ref.data,
	    data = _ref$data === undefined ? [] : _ref$data,
	    _ref$max = _ref.max,
	    max = _ref$max === undefined ? 100 : _ref$max,
	    includePercentage = _ref.includePercentage,
	    _ref$fill = _ref.fill,
	    fill = _ref$fill === undefined ? '#82DEBC' : _ref$fill,
	    secondHalfFill = _ref.secondHalfFill,
	    oddFill = _ref.oddFill,
	    keys = _ref.keys,
	    inView = _ref.inView,
	    degNum = _ref.degNum,
	    topTight = _ref.topTight;
	return Object(preact_min["h"])(
		components_LineWrapper,
		{ className: RadialChart_style_default.a.container, topTight: topTight },
		Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(RadialChart_style_default.a.container, (_cn = {}, _cn[RadialChart_style_default.a.hidden] = !inView, _cn)) },
			Object(preact_min["h"])(
				'div',
				{ className: RadialChart_style_default.a.wrapper },
				(keys || [max]).map(function (num) {
					return Object(preact_min["h"])(
						'div',
						{
							className: RadialChart_style_default.a.key,
							style: {
								width: calcAreaPercentage(num, max) + '%',
								height: calcAreaPercentage(num, max) + '%',
								transform: 'translate(-50%, -50%) scale(1) rotate(' + degNum + 'deg)'
							}
						},
						Object(preact_min["h"])(
							'div',
							{ className: RadialChart_style_default.a.keyInner },
							num,
							'%'
						)
					);
				}),
				Object(preact_min["h"])(
					'div',
					null,
					data.map(function (_ref2, i) {
						var fact = _ref2.fact,
						    description = _ref2.description,
						    percentage = _ref2.percentage;
						return Object(preact_min["h"])(
							'div',
							{ className: RadialChart_style_default.a.section },
							Object(preact_min["h"])(
								'div',
								{
									className: RadialChart_style_default.a.sliceWrap,
									style: {
										transitionDelay: 0.2 + 0.1 * i + 's'
									}
								},
								percentage.split(',').map(function (num, j) {
									return Object(preact_min["h"])(
										'svg',
										{
											className: RadialChart_style_default.a.slice,
											viewBox: '0 0 100 100',
											style: {
												transform: 'scale(' + calcAreaPercentage(+num, max) / 100 + ') rotate(' + i / data.length * 360 + 'deg) rotate(' + 60 / percentage.split(',').length * j + 'deg)'
											}
										},
										Object(preact_min["h"])('path', {
											d: 'M50,50 L50,0 L' + (50 + Math.tan(60 / percentage.split(',').length * Math.PI / 180) * 50) + ',0',
											'clip-path': 'url(#circle)',
											fill: getFill(fill, secondHalfFill, oddFill, i, j, data.length)
										})
									);
								})
							),
							Object(preact_min["h"])(
								'p',
								{
									className: RadialChart_style_default.a.text,
									style: {
										transitionDelay: 0.4 + 0.1 * i + 's'
									}
								},
								Object(preact_min["h"])(
									'span',
									{ className: RadialChart_style_default.a.textInner },
									includePercentage && Object(preact_min["h"])(
										'p',
										null,
										percentage,
										'%'
									),
									fact,
									description && Object(preact_min["h"])(
										'p',
										{ className: RadialChart_style_default.a.textDescriptionInner },
										description
									)
								)
							)
						);
					})
				)
			)
		)
	);
};

/* harmony default export */ var components_RadialChart = (RadialChart_RadialChart);
// EXTERNAL MODULE: ./components/LookCloser/style.css
var LookCloser_style = __webpack_require__("y6F2");
var LookCloser_style_default = /*#__PURE__*/__webpack_require__.n(LookCloser_style);

// CONCATENATED MODULE: ./components/LookCloser/index.js




var LookCloser_LookCloser = function LookCloser(_ref) {
	var _cn;

	var sized = _ref.sized;
	return Object(preact_min["h"])(
		'div',
		{ className: classnames_default()(LookCloser_style_default.a.container, (_cn = {}, _cn[LookCloser_style_default.a.sized] = sized, _cn)) },
		Object(preact_min["h"])(
			'div',
			{ className: LookCloser_style_default.a.inner },
			Object(preact_min["h"])(
				'div',
				{ className: LookCloser_style_default.a.emoji },
				'\uD83D\uDD0D'
			),
			Object(preact_min["h"])('div', { className: LookCloser_style_default.a.arrow }),
			Object(preact_min["h"])(
				'p',
				{ className: LookCloser_style_default.a.text },
				'Look closer'
			)
		)
	);
};

/* harmony default export */ var components_LookCloser = (LookCloser_LookCloser);
// EXTERNAL MODULE: ./components/ScaledPullOut/style.css
var ScaledPullOut_style = __webpack_require__("4ueM");
var ScaledPullOut_style_default = /*#__PURE__*/__webpack_require__.n(ScaledPullOut_style);

// CONCATENATED MODULE: ./components/ScaledPullOut/index.js
var ScaledPullOut__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var calcRadius = function calcRadius(value, max, size) {
	return Math.sqrt(value / max) * size;
};

var ScaledPullOut_ScaledPullOut = function ScaledPullOut(_ref) {
	var _cn, _cn2;

	var data = _ref.data,
	    copy = _ref.copy,
	    onRight = _ref.onRight,
	    inView = _ref.inView,
	    highlight = _ref.highlight,
	    highlightColors = _ref.highlightColors;

	var max = 65;
	var normalizedData = data.map(function (datum) {
		return ScaledPullOut__extends({}, datum, {
			radius: calcRadius(datum.percentage, max, 100)
		});
	});

	return Object(preact_min["h"])(
		components_TextWrapper,
		{
			copy: copy,
			highlight: highlight,
			highlightColors: highlightColors,
			onRight: !!onRight
		},
		Object(preact_min["h"])(
			'div',
			{
				className: classnames_default()((_cn = {}, _cn[ScaledPullOut_style_default.a.spaced] = data.length > 2, _cn[ScaledPullOut_style_default.a.sideRight] = onRight, _cn))
			},
			Object(preact_min["h"])(
				'div',
				{ className: ScaledPullOut_style_default.a.container },
				Object(preact_min["h"])(
					'div',
					{ className: classnames_default()(ScaledPullOut_style_default.a.chartWrapper, (_cn2 = {}, _cn2[ScaledPullOut_style_default.a.hidden] = !inView, _cn2)) },
					normalizedData.map(function (_ref2, i) {
						var _cn3;

						var fact = _ref2.fact,
						    percentage = _ref2.percentage,
						    color = _ref2.color,
						    radius = _ref2.radius,
						    factBelow = _ref2.factBelow;
						return Object(preact_min["h"])(
							'div',
							{ className: ScaledPullOut_style_default.a.responsive },
							Object(preact_min["h"])(
								'div',
								{ className: ScaledPullOut_style_default.a.circleWrap },
								Object(preact_min["h"])(
									'div',
									{
										className: ScaledPullOut_style_default.a.circle,
										style: {
											width: radius + '%',
											height: radius + '%',
											background: color
										}
									},
									Object(preact_min["h"])(
										'div',
										{
											className: classnames_default()(ScaledPullOut_style_default.a.fact, (_cn3 = {}, _cn3[ScaledPullOut_style_default.a.factBelow] = factBelow, _cn3)),
											style: {
												width: radius + '%'
											}
										},
										percentage,
										'% ',
										fact
									)
								)
							)
						);
					})
				)
			)
		)
	);
};

/* harmony default export */ var components_ScaledPullOut = (ScaledPullOut_ScaledPullOut);
// EXTERNAL MODULE: ./copy/physical.txt
var physical = __webpack_require__("ix8B");
var physical_default = /*#__PURE__*/__webpack_require__.n(physical);

// CONCATENATED MODULE: ./components/PhysicalChanges/index.js
















var PhysicalChanges__ref = Object(preact_min["h"])(
	components_ChartTitle,
	{ tag: 'h3', flush: true },
	physical["viz1Title"]
);

var PhysicalChanges__ref2 = Object(preact_min["h"])(components_LookCloser, null);

var PhysicalChanges__ref3 = Object(preact_min["h"])(
	components_ChartTitle,
	{ tag: 'h3', flush: true },
	physical["viz3Title"]
);

var _ref4 = Object(preact_min["h"])(
	components_ChartTitle,
	{ tight: true, tag: 'h3' },
	physical["viz4Title"]
);

var _ref5 = Object(preact_min["h"])(
	components_ChartTitle,
	{ tag: 'p' },
	physical["viz4Subtitle"]
);

var _ref6 = Object(preact_min["h"])(components_LookCloser, { sized: true });

var _ref7 = Object(preact_min["h"])(
	components_ChartTitle,
	{ tag: 'h3' },
	physical["viz6Title"]
);

var _ref8 = Object(preact_min["h"])(
	components_ChartTitle,
	{ tag: 'p' },
	physical["viz6Subtitle"]
);

var PhysicalChanges_PhysicalChanges = function PhysicalChanges() {
	return Object(preact_min["h"])(
		components_Chapter,
		{
			section: 2,
			title: physical["title"],
			standFirst: physical["standfirst"],
			highlight: ['52%']
		},
		PhysicalChanges__ref,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_RadialChart, {
					data: physical["viz1"],
					includePercentage: true,
					fill: '#82DEBC',
					max: 50,
					inView: inView
				});
			}
		}),
		PhysicalChanges__ref2,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_SliceChart, {
					data: physical["viz2"],
					copy: physical["viz2Title"],
					inView: inView,
					highlight: ['LGBTQ\\+'],
					highlightColors: ['#FECA98']
				});
			}
		}),
		PhysicalChanges__ref3,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_AreaComparison, {
					data: physical["viz3"],
					masterCirclePercentage: '100',
					inView: inView
				});
			}
		}),
		_ref4,
		_ref5,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_CircleGraph, { data: physical["viz4"], isAlternative: true, inView: inView });
			}
		}),
		_ref6,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_ScaledPullOut, {
					max: 100,
					copy: physical["viz5Title"],
					data: physical["viz5"],
					inView: inView,
					highlight: ['women', 'men'],
					highlightColors: ['#17ADA1', '#B3F36C']
				});
			}
		}),
		_ref7,
		_ref8,
		Object(preact_min["h"])(
			'p',
			{ className: PhysicalChanges_style_default.a.tight },
			physical["viz6Text1"]
		),
		Object(preact_min["h"])(components_TextComparison, {
			snugPadding: true,
			items: physical["viz6"].map(function (_ref9) {
				var fact = _ref9.fact,
				    number = _ref9.number;
				return number + ' ' + fact;
			})
		}),
		Object(preact_min["h"])(
			'p',
			{ className: PhysicalChanges_style_default.a.tight },
			physical["viz6Text2"]
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_EmojiGraph, { data: physical["viz6"], emoji: physical["viz6Emoji"], isEnd: true, inView: inView });
			}
		})
	);
};

/* harmony default export */ var components_PhysicalChanges = (PhysicalChanges_PhysicalChanges);
// EXTERNAL MODULE: ./components/VerbalChanges/style.css
var VerbalChanges_style = __webpack_require__("dwC8");
var VerbalChanges_style_default = /*#__PURE__*/__webpack_require__.n(VerbalChanges_style);

// EXTERNAL MODULE: ./components/EmojiWordsGraph/style.css
var EmojiWordsGraph_style = __webpack_require__("P6Dd");
var EmojiWordsGraph_style_default = /*#__PURE__*/__webpack_require__.n(EmojiWordsGraph_style);

// CONCATENATED MODULE: ./components/EmojiWordsGraph/index.js





var EmojiWordsGraph_EmojiWordsGraph = function EmojiWordsGraph(_ref) {
	var _cn;

	var data = _ref.data,
	    emoji = _ref.emoji,
	    isEnd = _ref.isEnd,
	    inView = _ref.inView;
	return Object(preact_min["h"])(
		components_LineWrapper,
		{ isEnd: isEnd },
		Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(EmojiWordsGraph_style_default.a.container, (_cn = {}, _cn[EmojiWordsGraph_style_default.a.hidden] = !inView, _cn)) },
			Object(preact_min["h"])(
				'ul',
				{ className: EmojiWordsGraph_style_default.a.list },
				data.map(function (_ref2, i) {
					var fact = _ref2.fact,
					    factEmoji = _ref2.factEmoji;

					if (i % 2) return false;
					return Object(preact_min["h"])(
						'li',
						{
							style: {
								transitionDelay: 0.1 * i + 's'
							},
							className: EmojiWordsGraph_style_default.a.item,
							'data-emoji': factEmoji
						},
						fact
					);
				})
			),
			Object(preact_min["h"])(
				'ul',
				{ className: classnames_default()(EmojiWordsGraph_style_default.a.list, EmojiWordsGraph_style_default.a.onRight) },
				data.map(function (_ref3, i) {
					var fact = _ref3.fact,
					    factEmoji = _ref3.factEmoji;

					if (!(i % 2)) return false;
					return Object(preact_min["h"])(
						'li',
						{
							style: {
								transitionDelay: 0.1 * i + 's'
							},
							className: EmojiWordsGraph_style_default.a.item,
							'data-emoji': factEmoji
						},
						fact
					);
				})
			)
		)
	);
};

/* harmony default export */ var components_EmojiWordsGraph = (EmojiWordsGraph_EmojiWordsGraph);
// EXTERNAL MODULE: ./components/EmojiGraphFaded/style.css
var EmojiGraphFaded_style = __webpack_require__("h9s4");
var EmojiGraphFaded_style_default = /*#__PURE__*/__webpack_require__.n(EmojiGraphFaded_style);

// CONCATENATED MODULE: ./components/EmojiGraphFaded/index.js






var EmojiGraphFaded_EmojiGraphFaded = function EmojiGraphFaded(_ref) {
	var _cn;

	var data = _ref.data,
	    emoji = _ref.emoji,
	    emoji2 = _ref.emoji2,
	    isEnd = _ref.isEnd,
	    inView = _ref.inView;

	var emojiNumber = function emojiNumber(respondents, totalRespondents, index) {
		if (emoji2 && index === 1) {
			emoji = emoji2;
		} else {
			emoji;
		}

		var emojiDiv = [];

		for (var i = 0; i < totalRespondents; i++) {
			if (i < respondents) {
				emojiDiv.push(Object(preact_min["h"])(
					'div',
					{
						style: {
							transitionDelay: i * 0.02 + 's'
						},
						className: EmojiGraphFaded_style_default.a.emoji
					},
					emoji
				));
			} else {
				emojiDiv.push(Object(preact_min["h"])(
					'div',
					{
						style: {
							transitionDelay: i * 0.02 + 's'
						},
						className: classnames_default()(EmojiGraphFaded_style_default.a.emoji, EmojiGraphFaded_style_default.a.emojiOpacity)
					},
					emoji
				));
			}
		}

		return emojiDiv;
	};

	return Object(preact_min["h"])(
		components_LineWrapper,
		{ isEnd: isEnd },
		Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(EmojiGraphFaded_style_default.a.container, (_cn = {}, _cn[EmojiGraphFaded_style_default.a.hidden] = !inView, _cn)) },
			data.map(function (data, index) {
				return Object(preact_min["h"])(
					'div',
					{ className: EmojiGraphFaded_style_default.a.emojiContainer },
					Object(preact_min["h"])(
						components_TextWithBackground,
						{
							tag: 'p',
							bg: 'transparent',
							highlight: [data.highlight || ''],
							highlightColors: ['yellow'],
							className: EmojiGraphFaded_style_default.a.emojiText
						},
						data.text
					),
					Object(preact_min["h"])(
						'div',
						{ className: EmojiGraphFaded_style_default.a.emojiWrapper },
						emojiNumber(data.respondents, data.totalRespondents, index)
					)
				);
			})
		)
	);
};

/* harmony default export */ var components_EmojiGraphFaded = (EmojiGraphFaded_EmojiGraphFaded);
// CONCATENATED MODULE: ./components/VerbalChanges/index.js











var VerbalChanges__ref2 = Object(preact_min["h"])(
	components_ChartTitle,
	{ tag: 'p', flush: true },
	'NSFW \uD83D\uDE4A'
);

var VerbalChanges_VerbalChanges = function VerbalChanges(_ref) {
	var title = _ref.title,
	    standFirstPer = _ref.standFirstPer,
	    standFirst = _ref.standFirst,
	    text1 = _ref.text1,
	    text2Per = _ref.text2Per,
	    text2 = _ref.text2,
	    text3 = _ref.text3,
	    text4 = _ref.text4,
	    text5 = _ref.text5,
	    viz1Title = _ref.viz1Title,
	    viz1 = _ref.viz1,
	    viz2Title = _ref.viz2Title,
	    viz2 = _ref.viz2,
	    viz3Title = _ref.viz3Title,
	    viz3 = _ref.viz3,
	    viz4Title = _ref.viz4Title,
	    viz4 = _ref.viz4,
	    viz5Title = _ref.viz5Title,
	    viz5 = _ref.viz5,
	    viz6Title = _ref.viz6Title,
	    viz6Text1 = _ref.viz6Text1,
	    viz6 = _ref.viz6,
	    viz6Text2 = _ref.viz6Text2,
	    verbalChangesViz4 = _ref.verbalChangesViz4,
	    verbalChangesViz2Title = _ref.verbalChangesViz2Title,
	    verbalChangesViz2 = _ref.verbalChangesViz2,
	    verbalChangesViz2Emoji = _ref.verbalChangesViz2Emoji;
	return Object(preact_min["h"])(
		components_Chapter,
		{
			section: 3,
			title: title,
			highlight: ['45%'],
			standFirst: standFirst
		},
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p' },
			text1
		),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', highlight: ['13%'], highlightColors: ['yellow'] },
			text2
		),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', bg: '#fff' },
			text3
		),
		Object(preact_min["h"])(
			components_TextWithBackground,
			{
				bg: 'transparent',
				tag: 'p',
				highlight: ['mocked'],
				highlightColors: ['#49BCB3'],
				className: VerbalChanges_style_default.a.tight
			},
			text4
		),
		Object(preact_min["h"])(
			components_TextWithBackground,
			{
				bg: 'transparent',
				tag: 'p',
				className: VerbalChanges_style_default.a.tight,
				highlight: ['ashamed'],
				highlightColors: ['#7DD4CD']
			},
			text5
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_RadialChart, {
					data: viz1,
					includePercentage: false,
					fill: '#49BCB3',
					oddFill: '#7DD4CD',
					keys: [25, 50],
					max: 50,
					degNum: -6,
					inView: inView
				});
			}
		}),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', flush: true },
			verbalChangesViz2Title
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_EmojiGraphFaded, {
					data: verbalChangesViz2,
					emoji: verbalChangesViz2Emoji,
					inView: inView
				});
			}
		}),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', tight: true },
			viz3Title
		),
		VerbalChanges__ref2,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_AreaComparison, {
					data: viz3,
					masterCircleSize: '292',
					masterCirclePercentage: '100',
					containerClass: VerbalChanges_style_default.a.viz3Container,
					wrapperClass: VerbalChanges_style_default.a.viz3Wrapper,
					numberClass: VerbalChanges_style_default.a.viz3Number,
					inView: inView,
					color: 'whiteBlue'
				});
			}
		}),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', flush: true },
			viz4Title
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_EmojiWordsGraph, { data: verbalChangesViz4, isEnd: true, inView: inView });
			}
		})
	);
};

/* harmony default export */ var components_VerbalChanges = (VerbalChanges_VerbalChanges);
// CONCATENATED MODULE: ./components/PersonalityChanges/index.js











var PersonalityChanges__ref3 = Object(preact_min["h"])(components_LookCloser, null);

var PersonalityChanges_PersonalityChanges = function PersonalityChanges(_ref) {
	var copy = _ref.copy;
	return Object(preact_min["h"])(
		components_Chapter,
		{
			section: 4,
			title: copy.personalityChangesTitle,
			standFirst: copy.personalityChangesStandfirst,
			highlight: ['52%']
		},
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p' },
			copy.personalityChangesText1
		),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p' },
			copy.personalityChangesText2
		),
		Object(preact_min["h"])(
			'p',
			null,
			copy.personalityChangesViz1Title
		),
		Object(preact_min["h"])(components_TextComparison, {
			snugPadding: true,
			items: copy.personalityChangesViz1SubTitle.map(function (_ref2) {
				var title = _ref2.title;
				return '' + title;
			})
		}),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_RadialChart, {
					data: copy.personalityChangesViz1,
					includePercentage: true,
					fill: '#709EEB',
					secondHalfFill: '#ffffff',
					keys: [50, 100],
					max: 100,
					degNum: '-45',
					inView: inView,
					topTight: true
				});
			}
		}),
		PersonalityChanges__ref3,
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_SliceChart, {
					data: copy.personalityChangesViz2,
					copy: copy.personalityChangesViz2Title,
					max: 100,
					inView: inView,
					highlight: ['Women', 'men'],
					highlightColors: ['#17ADA1', '#B3F36C']
				});
			}
		}),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_SliceChart, {
					data: copy.personalityChangesViz3,
					copy: copy.personalityChangesViz3Title,
					onRight: true,
					max: 100,
					inView: inView,
					highlight: ['straight men', 'LGBTQ\\+'],
					highlightColors: ['#86C93D', '#FECA98']
				});
			}
		}),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', flush: true },
			copy.personalityChangesViz4Title
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_EmojiGraphFaded, {
					data: copy.personalityChangesViz4,
					emoji: copy.personalityChangesViz4Emoji,
					inView: inView
				});
			}
		}),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p', flush: true },
			copy.personalityChangesViz5Title
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_EmojiWordsGraph, {
					data: copy.personalityChangesViz5,
					isEnd: true,
					inView: inView
				});
			}
		})
	);
};

/* harmony default export */ var components_PersonalityChanges = (PersonalityChanges_PersonalityChanges);
// EXTERNAL MODULE: ./components/RelatedContent/style.css
var RelatedContent_style = __webpack_require__("iOXE");
var RelatedContent_style_default = /*#__PURE__*/__webpack_require__.n(RelatedContent_style);

// CONCATENATED MODULE: ./components/RelatedContent/index.js




var RelatedContent_RelatedContent = function RelatedContent(_ref) {
	var title = _ref.title,
	    related = _ref.related;
	return Object(preact_min["h"])(
		'div',
		{ className: RelatedContent_style_default.a.root },
		Object(preact_min["h"])(
			components_Container,
			null,
			Object(preact_min["h"])(
				'h2',
				{ className: RelatedContent_style_default.a.title },
				title
			),
			Object(preact_min["h"])(
				'div',
				{ className: RelatedContent_style_default.a.related },
				related.map(function (_ref2) {
					var name = _ref2.name,
					    desc = _ref2.desc,
					    image = _ref2.image,
					    url = _ref2.url;
					return Object(preact_min["h"])(
						'a',
						{
							href: url,
							target: '_blank',
							rel: 'noopener noreferrer',
							className: RelatedContent_style_default.a.article
						},
						Object(preact_min["h"])('span', {
							className: RelatedContent_style_default.a.image,
							style: {
								backgroundImage: 'url(' + image + ')'
							}
						}),
						Object(preact_min["h"])(
							'h3',
							{ className: RelatedContent_style_default.a.name },
							Object(preact_min["h"])(
								'span',
								null,
								name
							)
						),
						Object(preact_min["h"])(
							'p',
							{ classNAme: RelatedContent_style_default.a.desc },
							desc
						)
					);
				})
			)
		)
	);
};

/* harmony default export */ var components_RelatedContent = (RelatedContent_RelatedContent);
// EXTERNAL MODULE: ./components/Conclusion/style.css
var Conclusion_style = __webpack_require__("2O4m");
var Conclusion_style_default = /*#__PURE__*/__webpack_require__.n(Conclusion_style);

// CONCATENATED MODULE: ./components/Conclusion/index.js









var Conclusion_Conclusion = function Conclusion(_ref) {
	var copy = _ref.copy;
	return Object(preact_min["h"])(
		components_Chapter,
		{
			onRight: true,
			section: 5,
			title: copy.conclusionTitle,
			standFirst: copy.conclusionStandfirst
		},
		Object(preact_min["h"])(
			components_ChartTitle,
			{ flush: true, tag: 'p' },
			copy.conclusionViz1Title
		),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_EmojiGraphFaded, {
					data: copy.conclusionViz1,
					emoji: copy.conclusionViz1Emoji,
					emoji2: copy.conclusionViz1Emoji2,
					inView: inView
				});
			}
		}),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p' },
			copy.conclusionText1
		),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ tag: 'p' },
			copy.conclusionText2
		),
		Object(preact_min["h"])(
			components_ChartTitle,
			{ flush: true, tag: 'p' },
			copy.conclusionText3
		),
		Object(preact_min["h"])(components_TextComparison, { items: [' ', ' '] }),
		Object(preact_min["h"])(components_TextComparison, {
			items: copy.conclusionViz2SubTitle.map(function (_ref2) {
				var title = _ref2.title;
				return '' + title;
			})
		}),
		Object(preact_min["h"])(components_InView, {
			render: function render(inView) {
				return Object(preact_min["h"])(components_AreaComparison, {
					isEnd: true,
					data: copy.conclusionViz2,
					masterCircleSize: '292',
					masterCirclePercentage: '100',
					containerClass: Conclusion_style_default.a.viz2Container,
					wrapperClass: Conclusion_style_default.a.viz2Wrapper,
					numberClass: Conclusion_style_default.a.viz2Number,
					inView: inView,
					color: 'blueWhite',
					topTight: true
				});
			}
		})
	);
};

/* harmony default export */ var components_Conclusion = (Conclusion_Conclusion);
// EXTERNAL MODULE: ./components/Footer/style.css
var Footer_style = __webpack_require__("n4o+");
var Footer_style_default = /*#__PURE__*/__webpack_require__.n(Footer_style);

// CONCATENATED MODULE: ./components/Footer/index.js





var Footer__ref2 = Object(preact_min["h"])(components_Logo, { trim: true });

var Footer__ref3 = Object(preact_min["h"])('br', null);

var Footer__ref4 = Object(preact_min["h"])(
	'p',
	null,
	'Created in collaboration with',
	' ',
	Object(preact_min["h"])(
		'a',
		{
			href: 'https://beyondwordsstudio.com/?utm_source=totaljobs-covering-footer',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		'Beyond Words Studio'
	),
	'.'
);

var Footer_Footer = function Footer(_ref) {
	var sourceTitle = _ref.sourceTitle,
	    sourceText = _ref.sourceText;
	return Object(preact_min["h"])(
		'div',
		{ className: Footer_style_default.a.footer },
		Object(preact_min["h"])(
			components_Container,
			null,
			Object(preact_min["h"])(
				'p',
				{ className: Footer_style_default.a.logo },
				Footer__ref2
			),
			Object(preact_min["h"])(
				'p',
				null,
				Object(preact_min["h"])(
					'strong',
					null,
					sourceTitle
				),
				' ',
				Footer__ref3,
				sourceText
			),
			Footer__ref4
		)
	);
};

/* harmony default export */ var components_Footer = (Footer_Footer);
// EXTERNAL MODULE: ./copy.txt
var copy_0 = __webpack_require__("YUl8");
var copy_default = /*#__PURE__*/__webpack_require__.n(copy_0);

// CONCATENATED MODULE: ./index.js













if (false) {
	require('preact/debug');
}

var index__ref = Object(preact_min["h"])('circle', { cx: '50', cy: '50', r: '50' });

var index__ref2 = Object(preact_min["h"])(components_Intro, null);

var index__ref3 = Object(preact_min["h"])(components_IntroViz, null);

var index__ref4 = Object(preact_min["h"])(components_PhysicalChanges, null);

var index__ref5 = Object(preact_min["h"])(components_PersonalityChanges, { copy: copy_default.a });

var index__ref6 = Object(preact_min["h"])(components_Conclusion, { copy: copy_default.a });

/* harmony default export */ var index_0 = __webpack_exports__["default"] = (function () {
	return Object(preact_min["h"])(
		'div',
		null,
		Object(preact_min["h"])(
			'svg',
			{
				viewBox: '0 0 100 100',
				style: {
					position: 'absolute',
					top: -9999,
					left: -9999
				}
			},
			Object(preact_min["h"])(
				'defs',
				null,
				Object(preact_min["h"])(
					'clipPath',
					{ id: 'circle' },
					index__ref
				)
			)
		),
		Object(preact_min["h"])(components_Header, { tweetText: copy_default.a.tweetText }),
		index__ref2,
		index__ref3,
		index__ref4,
		Object(preact_min["h"])(components_VerbalChanges, {
			title: copy_default.a.verbalChangesTitle,
			standFirstPer: copy_default.a.verbalChangesStandfirstPer,
			standFirst: copy_default.a.verbalChangesStandfirst,
			verbalChangesViz4: copy_default.a.verbalChangesViz4,
			verbalChangesViz2Title: copy_default.a.verbalChangesViz2Title,
			verbalChangesViz2: copy_default.a.verbalChangesViz2,
			verbalChangesViz2Emoji: copy_default.a.verbalChangesViz2Emoji,
			text1: copy_default.a.verbalChangesText1,
			text2: copy_default.a.verbalChangesText2,
			text3: copy_default.a.verbalChangesText3,
			text4: copy_default.a.verbalChangesText4,
			text5: copy_default.a.verbalChangesText5,
			viz1: copy_default.a.verbalChangesViz1,
			viz3: copy_default.a.verbalChangesViz3,
			viz3Title: copy_default.a.verbalChangesViz3Title,
			viz4Title: copy_default.a.verbalChangesViz4Title
		}),
		index__ref5,
		index__ref6,
		Object(preact_min["h"])(components_RelatedContent, {
			title: copy_default.a.relatedContentTitle,
			related: copy_default.a.relatedContent
		}),
		Object(preact_min["h"])(components_Footer, { sourceTitle: copy_default.a.sourceTitle, sourceText: copy_default.a.sourceText })
	);
});

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = M;for (i = arguments.length; i-- > 2;) {
      T.push(arguments[i]);
    }t && null != t.children && (T.length || T.push(t.children), delete t.children);while (T.length) {
      if ((o = T.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        T.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === M ? l = [o] : l.push(o), n = r;
    }var a = new S();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== L.vnode && L.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function o(e) {
    !e.__d && (e.__d = !0) && 1 == D.push(e) && (L.debounceRendering || P)(r);
  }function r() {
    var e,
        t = D;D = [];while (e = t.pop()) {
      e.__d && C(e);
    }
  }function i(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && l(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function l(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function a(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function p(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function u(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === W.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, s, l) : e.removeEventListener(t, s, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) {
        try {
          e[t] = null == o ? "" : o;
        } catch (e) {}null != o && !1 !== o || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e) {
    return this.__l[e.type](L.event && L.event(e) || e);
  }function _() {
    var e;while (e = E.pop()) {
      L.afterMount && L.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    V++ || (A = null != r && void 0 !== r.ownerSVGElement, H = null != e && !("__preactattr_" in e));var l = f(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --V || (H = !1, i || _()), l;
  }function f(e, t, n, o, r) {
    var i = e,
        a = A;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), m(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return x(e, t, n, o);if (A = "svg" === u || "foreignObject" !== u && A, u += "", (!e || !l(e, u)) && (i = p(u, A), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), m(e, !0);
    }var c = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var d = i.attributes, f = d.length; f--;) {
        s[d[f].name] = d[f].value;
      }
    }return !H && _ && 1 === _.length && "string" == typeof _[0] && null != c && void 0 !== c.splitText && null == c.nextSibling ? c.nodeValue != _[0] && (c.nodeValue = _[0]) : (_ && _.length || null != c) && h(i, _, n, o, H || null != s.dangerouslySetInnerHTML), b(i, t.attributes, s), A = a, i;
  }function h(e, t, n, o, r) {
    var l,
        a,
        p,
        c,
        s,
        _ = e.childNodes,
        d = [],
        h = {},
        v = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (v++, h[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (d[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) v && void 0 !== h[k] && (s = h[k], h[k] = void 0, v--);else if (b < g) for (l = b; l < g; l++) {
        if (void 0 !== d[l] && i(a = d[l], c, r)) {
          s = a, d[l] = void 0, l === g - 1 && g--, l === b && b++;break;
        }
      }s = f(s, c, n, o), p = _[C], s && s !== e && s !== p && (null == p ? e.appendChild(s) : s === p.nextSibling ? u(p) : e.insertBefore(s, p));
    }if (v) for (var C in h) {
      void 0 !== h[C] && m(h[C], !1);
    }while (b <= g) {
      void 0 !== (s = d[g--]) && m(s, !1);
    }
  }function m(e, t) {
    var n = e._component;n ? N(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || u(e), v(e));
  }function v(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;m(e, !0), e = t;
    }
  }function b(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, A);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], A);
    }
  }function y(e, t, n) {
    var o,
        r = B.length;e.prototype && e.prototype.render ? (o = new e(t, n), k.call(o, t, n)) : (o = new k(t, n), o.constructor = e, o.render = g);while (r--) {
      if (B[r].constructor === e) return o.__b = B[r].__b, B.splice(r, 1), o;
    }return o;
  }function g(e, t, n) {
    return this.constructor(e, n);
  }function w(e, t, n, r, i) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, r)), r && r !== e.context && (e.__c || (e.__c = e.context), e.context = r), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === L.syncComponentUpdates && e.base ? o(e) : C(e, 1, i)), e.__r && e.__r(e));
  }function C(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          p,
          u = e.props,
          c = e.state,
          s = e.context,
          f = e.__p || u,
          h = e.__s || c,
          v = e.__c || s,
          b = e.base,
          g = e.__b,
          x = b || g,
          k = e._component,
          U = !1,
          S = v;if (e.constructor.getDerivedStateFromProps && (c = t(t({}, c), e.constructor.getDerivedStateFromProps(u, c)), e.state = c), b && (e.props = f, e.state = h, e.context = v, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(u, c, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(u, c, s), e.props = u, e.state = c, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(u, c, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(f, h));var T,
            M,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = a(i);l = k, l && l.constructor === P && W.key == l.__k ? w(l, W, 1, s, !1) : (T = l, e._component = l = y(P, W, s), l.__b = l.__b || g, l.__u = e, w(l, W, 0, s, !1), C(l, 1, o, !0)), M = l.base;
        } else p = x, T = k, T && (p = e._component = null), (x || 1 === n) && (p && (p._component = null), M = d(p, i, s, o || !b, x && x.parentNode, !0));if (x && M !== x && l !== k) {
          var D = x.parentNode;D && M !== D && (D.replaceChild(M, x), T || (x._component = null, m(x, !1)));
        }if (T && N(T), e.base = M, M && !r) {
          var A = e,
              H = e;while (H = H.__u) {
            (A = H).base = M;
          }M._component = A, M._componentConstructor = A.constructor;
        }
      }!b || o ? E.unshift(e) : U || (e.componentDidUpdate && e.componentDidUpdate(f, h, S), L.afterUpdate && L.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }V || r || _();
    }
  }function x(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        p = r && e._componentConstructor === t.nodeName,
        u = p,
        c = a(t);while (r && !u && (r = r.__u)) {
      u = r.constructor === t.nodeName;
    }return r && u && (!o || r._component) ? (w(r, c, 3, n, o), e = r.base) : (i && !p && (N(i), e = l = null), r = y(t.nodeName, c, n), e && !r.__b && (r.__b = e, l = null), w(r, c, 1, n, o), e = r.base, l && e !== l && (l._component = null, m(l, !1))), e;
  }function N(e) {
    L.beforeUnmount && L.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? N(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, u(t), B.push(e), v(t)), e.__r && e.__r(null);
  }function k(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function U(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }var S = function S() {},
      L = {},
      T = [],
      M = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      W = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      D = [],
      E = [],
      V = 0,
      A = !1,
      H = !1,
      B = [];t(k.prototype, { setState: function setState(e, n) {
      var r = this.__s = this.state;"function" == typeof e && (e = e(r, this.props)), this.state = t(t({}, r), e), n && this.__h.push(n), o(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), C(this, 2);
    }, render: function render() {} });var F = { h: e, createElement: e, cloneElement: n, Component: k, render: U, rerender: r, options: L }; true ? module.exports = F : self.preact = F;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "P6Dd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3DTIf","list":"list__1YuS_","item":"item__2Es3g","onRight":"onRight__1tEEI","hidden":"hidden__2laPJ"};

/***/ }),

/***/ "RtUu":
/***/ (function(module, exports) {

module.exports = {
	"title": "Subject to change",
	"standfirst": "Do you hide your true self at work to win praise, promotion or even just acceptance? You’re not the only one. It’s called ‘covering’.",
	"miniTitle": "Covering",
	"miniDesc": "noun",
	"sectionIntro": "The act of changing your true self at work. This could mean:",
	"sections": [
		{
			"text": "Physical changes: your clothes, makeup or jewellery",
			"emoji": "👕"
		},
		{
			"text": "Verbal changes: your accent or your potty mouth",
			"emoji": "👄"
		},
		{
			"text": "Personality changes: your character or behaviour",
			"emoji": "🎭"
		}
	],
	"fact": "We asked 4,000 of you if you cover at work – and how. Here’s what you revealed…",
	"vizTitle": [
		{
			"text": "💼 New job, new you"
		},
		{
			"text": "Covering can start even before your first day on the job."
		}
	],
	"respondents": "% of respondents",
	"viz": [
		{
			"fact": "The majority of us hide our real personality during a job interview",
			"percentage": "62"
		},
		{
			"fact": "And we continue to cover when we start the new job",
			"percentage": "62"
		},
		{
			"fact": "It's not until we pass probation that most of us stop disguising our true selves",
			"percentage": "25"
		},
		{
			"fact": "Although the office party can make some of us want to put our disguises back on 🎉",
			"percentage": "45"
		}
	]
};

/***/ }),

/***/ "WL61":
/***/ (function(module, exports, __webpack_require__) {

// Inspiration: https://github.com/facebook/react/issues/3386

var invariant = __webpack_require__("2gTp"),
    isString = __webpack_require__("eMen"),
    flatten = __webpack_require__("bljh");

function replace(string, regexpOrSubstr, newValueOrFn) {
	invariant(typeof string === 'string', 'First param must be a string');
	invariant(typeof regexpOrSubstr === 'string' || regexpOrSubstr instanceof RegExp, 'Second param must be a string pattern or a regular expression');

	var fn = typeof regexpOrSubstr === 'string' ? replaceUsingString : replaceUsingRegexp;

	return fn(string, regexpOrSubstr, newValueOrFn);
}

function replaceUsingString(string, patternString, newValueOrFn) {
	var index = string.indexOf(patternString);

	if (index >= 0) {
		var arr = [];
		var endIndex = index + patternString.length;

		if (index > 0) {
			arr.push(string.substring(0, index));
		}

		arr.push(typeof newValueOrFn === 'function' ? newValueOrFn(string.substring(index, endIndex), index, string) : newValueOrFn);

		if (endIndex < string.length) {
			arr.push(string.substring(endIndex));
		}

		return arr;
	} else {
		return [string];
	}
}

function replaceUsingRegexp(string, regexp, newValueOrFn) {
	var output = [];

	var replacerIsFn = typeof newValueOrFn === 'function';

	var storedLastIndex = regexp.lastIndex;
	regexp.lastIndex = 0;

	var result;
	var lastIndex = 0;
	while (result = regexp.exec(string)) {
		var index = result.index;

		if (result[0] === '') {
			// When the regexp is an empty string
			// we still want to advance our cursor to the next item.
			// This is the behavior of String.replace.
			regexp.lastIndex++;
		}

		if (index !== lastIndex) {
			output.push(string.substring(lastIndex, index));
		}

		var match = result[0];
		lastIndex = index + match.length;

		var out = replacerIsFn ? newValueOrFn.apply(this, result.concat(index, result.input)) : newValueOrFn;
		output.push(out);

		if (!regexp.global) {
			break;
		}
	}

	if (lastIndex < string.length) {
		output.push(string.substring(lastIndex));
	}

	regexp.lastIndex = storedLastIndex;
	return output;
}

module.exports = function stringReplaceToArray(string, regexpOrSubstr, newSubStrOrFn) {
	if (isString(string)) {
		return replace(string, regexpOrSubstr, newSubStrOrFn);
	} else if (!Array.isArray(string) || !string[0]) {
		throw new TypeError('First argument must be an array or non-empty string');
	} else {
		return flatten(string.map(function (string) {
			if (!isString(string)) return string;
			return replace(string, regexpOrSubstr, newSubStrOrFn);
		}));
	}
};

/***/ }),

/***/ "WqJV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tight":"tight__2qO2a"};

/***/ }),

/***/ "YUl8":
/***/ (function(module, exports) {

module.exports = {
	"pageTitle": "Subject to change | totaljobs",
	"pageDescription": "Is ‘covering’ the biggest unspoken secret of UK work-life?",
	"tweetText": "Do you hide your true self at work to win praise, promotion to even just acceptance? You’re not the only one. Discover ‘covering’ in the workplace with @totaljobsuk.",
	"verbalChangesTitle": "Verbal changes",
	"verbalChangesStandfirstPer": "45",
	"verbalChangesStandfirst": "Remarkably, 45% of people think it's normal to change the way you speak at work.",
	"verbalChangesText1": "And maybe it’s not surprising we’re hiding our true voices 🤐",
	"verbalChangesText2per": "13",
	"verbalChangesText2": "13% of you admit to having thought less of someone or mocked 😓 someone at work because of their accent.",
	"verbalChangesText3": "For people with accents, work isn’t always a safe space.",
	"verbalChangesText4feeling": "mocked",
	"verbalChangesText5feeling": "ashamed",
	"verbalChangesText4": "% of respondents who were mocked vs.",
	"verbalChangesText5": "% of respondents who felt ashamed",
	"verbalChangesViz1": [
		{
			"fact": "At work",
			"description": "Work is the place we're most likely to be mocked for our accents or feel ashamed of them",
			"percentage": "36, 12"
		},
		{
			"fact": "With friends",
			"percentage": "35, 5"
		},
		{
			"fact": "With strangers",
			"percentage": "20, 9"
		},
		{
			"fact": "At school",
			"percentage": "17, 5"
		},
		{
			"fact": "At university",
			"description": "Uni is the place we're least likely to feel ashamed of our accents",
			"percentage": "11, 4"
		},
		{
			"fact": "Interview",
			"description": "Job interviews are where we often feel ashamed of our accents, yet are least likely to be mocked",
			"percentage": "5, 9"
		}
	],
	"verbalChangesViz2Title": "Maybe it’s not surprising, then, that people are more likely to tone down their accent for a job interview 📝 than for a date 💕",
	"verbalChangesViz2Emoji": "😶",
	"verbalChangesViz2": [
		{
			"respondents": "4",
			"totalRespondents": "10",
			"text": "4 in 10 respondents with an accent would tone it down in a job interview",
			"highlight": "4 in 10"
		},
		{
			"respondents": "2",
			"totalRespondents": "10",
			"text": "2 in 10 respondents with an accent would tone it down on a date",
			"highlight": "2 in 10"
		}
	],
	"verbalChangesViz3Title": "Oh, and as for swearing on the job?",
	"verbalChangesViz3": [
		{
			"fact": "swear in front of grandparents",
			"percentage": "16"
		},
		{
			"fact": "swear in front of clients",
			"percentage": "7"
		}
	],
	"verbalChangesViz4Title": "And here are the justifications they gave…",
	"verbalChangesViz4": [
		{
			"factEmoji": "🖥",
			"fact": "“I swear at my computer. It is a shame I cannot do more to it in order to make it behave”"
		},
		{
			"factEmoji": "🔪",
			"fact": "“If you cut your hand with a knife what are you supposed to say?”"
		},
		{
			"factEmoji": "🗣",
			"fact": "“Banter with others”"
		},
		{
			"factEmoji": "‼️",
			"fact": "“To act like a normal f****** person”"
		},
		{
			"factEmoji": "🌸",
			"fact": "“Not heavy swearing, just things like damn, blooming”"
		},
		{
			"factEmoji": "❌",
			"fact": "“Only with trusted colleagues and no women around”"
		},
		{
			"factEmoji": "💨",
			"fact": "“Release :)”"
		},
		{
			"factEmoji": "😶",
			"fact": "“I only swear quietly\""
		}
	],
	"personalityChangesTitle": "Personality changes",
	"personalityChangesStandfirstPer": "52",
	"personalityChangesStandfirst": "Most dramatically of all, 52% think people should change their personality 🎭 at work.",
	"personalityChangesText1": "And it seems to make a difference.",
	"personalityChangesText2": "When people change their personality at work, they feel much more comfortable 🛀 and confident 😜... Yet they also feel more stressed 😫",
	"personalityChangesViz1Title": "% of respondents who change their personality and feel...",
	"personalityChangesViz1SubTitle": [
		{
			"title": "Negative feelings 👎🏼"
		},
		{
			"title": "👍🏼 Positive feelings"
		}
	],
	"personalityChangesViz1": [
		{
			"fact": "Amused",
			"percentage": "11"
		},
		{
			"fact": "Confident",
			"percentage": "43"
		},
		{
			"fact": "Comfortable",
			"percentage": "46"
		},
		{
			"fact": "Stressed",
			"percentage": "28"
		},
		{
			"fact": "Exposed",
			"percentage": "11"
		},
		{
			"fact": "Ashamed",
			"percentage": "7"
		}
	],
	"personalityChangesViz2Pop1": "Women",
	"personalityChangesViz2Pop2": "men",
	"personalityChangesViz2Title": "Women find changing their personality at work more stressful than men do",
	"personalityChangesViz2": [
		{
			"fact": "of men",
			"percentage": "25",
			"color": "#B3F36C"
		},
		{
			"fact": "of all",
			"percentage": "28",
			"color": "#fff"
		},
		{
			"fact": "of women",
			"percentage": "32",
			"color": "#17ADA1"
		}
	],
	"personalityChangesViz3Pop1": "straight men",
	"personalityChangesViz3Pop2": "LGBTQ+",
	"personalityChangesViz3Title": "And straight men feel more comfortable changing their personalities compared to LGBTQ+ respondents",
	"personalityChangesViz3": [
		{
			"fact": "of LGBTQ+",
			"percentage": "38",
			"color": "#FECA98"
		},
		{
			"fact": "of all",
			"percentage": "46",
			"color": "#709EEB"
		},
		{
			"fact": "of straight men",
			"percentage": "50",
			"color": "#86C93D"
		}
	],
	"personalityChangesViz4Title": "Why might these be the groups of people that feel least comfortable and most stressed? Perhaps it’s because…",
	"personalityChangesViz4Emoji": "👌🏾",
	"personalityChangesViz4": [
		{
			"respondents": "7",
			"totalRespondents": "10",
			"text": "7 in 10 respondents think we should stick up for groups such as women, LGBTQ+ and disabled people at work",
			"highlight": "7 in 10"
		},
		{
			"respondents": "5",
			"totalRespondents": "10",
			"text": "But only 5 in 10 respondents say they actually do",
			"highlight": "5 in 10"
		}
	],
	"personalityChangesViz5Title": "Here's how changing their personality made people feel…",
	"personalityChangesViz5": [
		{
			"factEmoji": "🔪",
			"fact": "“Safer from back-stabbers”"
		},
		{
			"factEmoji": "👽",
			"fact": "“Alien”"
		},
		{
			"factEmoji": "👑",
			"fact": "“IN CONTROL”"
		},
		{
			"factEmoji": "🎨",
			"fact": "“Like I’m hiding my true colours”"
		},
		{
			"factEmoji": "🛡",
			"fact": "“Armoured (protected)”"
		},
		{
			"factEmoji": "👏🏽",
			"fact": "“To appear like putty in their hands, when actually I have manipulated them into getting projects finished in a timely manner”"
		},
		{
			"factEmoji": "📌",
			"fact": "“It’s what needs to be done to be professional. That’s that”"
		}
	],
	"conclusionTitle": "Conclusion",
	"conclusionStandfirst": "But what happens when a company encourages you to be your true self 👯?",
	"conclusionViz1Title": "There’s a clear relationship between being inclusive in the workplace and job satisfaction.",
	"conclusionViz1Emoji": "😕",
	"conclusionViz1Emoji2": "😊",
	"conclusionViz1": [
		{
			"respondents": "5",
			"totalRespondents": "10",
			"text": "Of those respondents that are dissatisfied ☹️ with their job, 5 in 10 work for an inclusive company",
			"highlight": "5 in 10"
		},
		{
			"respondents": "8",
			"totalRespondents": "10",
			"text": "Of those respondents that are satisfied 😊 with their job, 8 in 10 work for an inclusive company",
			"highlight": "8 in 10"
		}
	],
	"conclusionText1": "But does that mean you’re more likely to be true to yourself if you work at an inclusive company?",
	"conclusionText2": "🤔 Interestingly, no...",
	"conclusionText3": "Even if you work for a company that’s inclusive, people still feel the need to change who they are at work 🙃",
	"conclusionText4": "Of those respondents that work for an inclusive company…",
	"conclusionText5": "Of those respondents that don’t work for an inclusive company…",
	"conclusionViz2SubTitle": [
		{
			"title": "Of those respondents that work for an inclusive company…"
		},
		{
			"title": "Of those respondents that don’t work for an inclusive company…"
		}
	],
	"conclusionViz2": [
		{
			"fact": "change their personality",
			"percentage": "52"
		},
		{
			"fact": "change their personality",
			"percentage": "52"
		}
	],
	"relatedContentTitle": "Keep exploring your work-self",
	"relatedContent": [
		{
			"name": "Covering your true self",
			"desc": "Why do we often feel we can't be our true self at work?",
			"image": "assets/personality.svg",
			"url": "https://www.totaljobs.com/insidejob/bringing-your-true-self-to-work/"
		},
		{
			"name": "Displaced in the workplace",
			"desc": "LGBTQ+ advocate Rhammel Afflick explores our research on covering.",
			"image": "assets/lgbtq.svg",
			"url": "https://www.totaljobs.com/insidejob/lgbtq-people-continue-to-feel-displaced-in-the-workplace/"
		}
	],
	"sourceTitle": "Survey data",
	"sourceText": "Totaljobs research of 4,127 UK workers in May 2018."
};

/***/ }),

/***/ "Zr0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"vizContainer":"vizContainer__37wJu","fact":"fact__-kAn8","alternative":"alternative__gp16l","responsive":"responsive__3Ztcv","bubbleWrap":"bubbleWrap__290nC","bubble":"bubble__3_p39","bubbleText":"bubbleText__1tqeV","label":"label__2E0e-","hidden":"hidden__1m8KE"};

/***/ }),

/***/ "Zu9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__1NZfD","isEnd":"isEnd__2-KcL","plain":"plain__pVuHc","tight":"tight__2rIhS","snugPadding":"snugPadding__Vwf1K","trim":"trim__2gqg5","topTight":"topTight__KL0fy"};

/***/ }),

/***/ "bljh":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "cs8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1-v59","vizContainer":"vizContainer__1oTcF","circleWrapper":"circleWrapper__3ff_6","circle":"circle__3-NqO","vizParagraph":"vizParagraph__1jM6v","hidden":"hidden__3ljvp","whiteBlue":"whiteBlue__3wFEj","blueWhite":"blueWhite__3QAU5"};

/***/ }),

/***/ "dwC8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tight":"tight__3L15l"};

/***/ }),

/***/ "eMen":
/***/ (function(module, exports) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag;
}

module.exports = isString;

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export version */
/* unused harmony export DOM */
/* unused harmony export Children */
/* unused harmony export render */
/* unused harmony export createClass */
/* unused harmony export createPortal */
/* unused harmony export createFactory */
/* unused harmony export createElement */
/* unused harmony export cloneElement */
/* unused harmony export isValidElement */
/* unused harmony export findDOMNode */
/* unused harmony export unmountComponentAtNode */
/* unused harmony export Component */
/* unused harmony export PureComponent */
/* unused harmony export unstable_renderSubtreeIntoContainer */
/* unused harmony export unstable_batchedUpdates */
/* unused harmony export __spread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* unused harmony reexport PropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);




var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process !== 'undefined' && process.env && "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["a"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "h0Qy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo__1WUr8","trim":"trim__10ZUh"};

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "h9s4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3fTbZ","emojiWrapper":"emojiWrapper__RVA6n","emoji":"emoji__2CfDu","emojiOpacity":"emojiOpacity__1iPvA","hidden":"hidden__BVzIg","emojiText":"emojiText__23G_r","emojiContainer":"emojiContainer__2qB9K"};

/***/ }),

/***/ "iOXE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__PqsSH","title":"title__1Y1VF","related":"related__1Yq4s","article":"article__3zmHB","name":"name__2aEAs","image":"image__16Nfu"};

/***/ }),

/***/ "ix8B":
/***/ (function(module, exports) {

module.exports = {
	"title": "Physical changes",
	"standfirst": "52% think that people should change their appearance 👡 in order to fit in at work.",
	"viz1Title": "But why do we change our appearance at work?",
	"viz1": [
		{
			"fact": "Nature of the job",
			"percentage": "45"
		},
		{
			"fact": "Typical style doesn’t fit in with company style",
			"percentage": "14"
		},
		{
			"fact": "Typical style wouldn’t make a good impression",
			"percentage": "13"
		},
		{
			"fact": "Have been discriminated against",
			"percentage": "6"
		},
		{
			"fact": "Don’t want to draw attention to ethnicity",
			"percentage": "5"
		},
		{
			"fact": "Don’t want to draw attention to socio-economic background",
			"percentage": "4"
		}
	],
	"viz2Title": "If you’re LGBTQ+ you’re twice as likely to change your appearance at work because you’ve been discriminated against",
	"viz2": [
		{
			"fact": "of all",
			"percentage": "6",
			"color": "#82DEBC"
		},
		{
			"fact": "of LGBTQ+",
			"percentage": "12",
			"color": "#FECA98"
		}
	],
	"viz3Title": "Most people have no problem with tattoos ☠️🌹 at work, but many still worry 😰 about their body ink.",
	"viz3": [
		{
			"fact": "of respondents with tattoos are worried about people seeing them at work",
			"percentage": "42"
		},
		{
			"fact": "of respondents have no problem with tattoos at work",
			"percentage": "62"
		}
	],
	"viz4Title": "Why?",
	"viz4Subtitle": "When you have visible tattoos, respondents think…",
	"viz4": [
		{
			"fact": "It’s harder to get a job",
			"percentage": "60"
		},
		{
			"fact": "It's harder to be promoted",
			"percentage": "46"
		},
		{
			"fact": "Women are more likely to be discriminated against",
			"percentage": "48"
		},
		{
			"fact": "It's harder to be taken seriously at work",
			"percentage": "42"
		}
	],
	"viz5Title": "More women than men tend to think females are most likely to be discriminated against for tattoos",
	"viz5": [
		{
			"fact": "of women",
			"percentage": "58",
			"color": "#17ADA1",
			"factBelow": "true"
		},
		{
			"fact": "of men",
			"percentage": "39",
			"color": "#B3F36C"
		}
	],
	"viz6Title": "How about jewellery 💍?",
	"viz6Subtitle": "For some, it reveals a little too much. Including the fact you’re married.",
	"viz6Text1": "Out of 4,127 respondents...",
	"viz6Text2": "admitted to removing their wedding ring at work",
	"viz6Emoji": "💍",
	"viz6": [
		{
			"fact": "men",
			"number": "10"
		},
		{
			"fact": "women",
			"number": "13"
		}
	]
};

/***/ }),

/***/ "l8Hw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__1biTz","beginArrow":"beginArrow__1DwO-","shortArrow":"shortArrow__1Nv7a","endArrow":"endArrow__2sss-","title":"title__TFCKp","standfirst":"standfirst__2H8iz","descContainer":"descContainer__2n-jR","descWrapper":"descWrapper__3fGGc","descName":"descName__2n-cH","descNoun":"descNoun__10zPF","descriptionCopyContainer":"descriptionCopyContainer__2Zjd6","descriptionCopy":"descriptionCopy__3K9jl","introFact":"introFact__2tf3J"};

/***/ }),

/***/ "n4o+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__34BaK","logo":"logo__3txfA"};

/***/ }),

/***/ "nzRV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  // https://mths.be/emoji
  return (/\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g
  );
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "vstC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sectionTitleWrapper":"sectionTitleWrapper__13GbX","title":"title__60nrB"};

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "y6F2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__g9QiG","sized":"sized__3j1m8","inner":"inner__21PkP","text":"text__3c3WB","emoji":"emoji__QJC8D"};

/***/ }),

/***/ "yE6s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2dmUM","emojiWrapper":"emojiWrapper__ZJj01","emoji":"emoji__Su6vK","hidden":"hidden__wwVVJ"};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.1fdbf.js